<template>
    <div id="content" style="height: 100%;" v-if="load">
        <div id="messageWrap" class="font_small" style="height: 100%;">
            <div class="userinfo">
                <div style="display: flex; width: 100%; justify-content: space-between;font-size: 15px;">
                    <div style="padding-left: 5px; text-align: left; cursor: pointer;width: 33%;"
                        @click="$router.back()"><i class="van-badge__wrapper van-icon van-icon-arrow-left"></i>
                        {{gname.name}}
                    </div>
                    <div style="width: 33%;">{{user.NickName}}</div>
                    <div style="text-align: right;padding-right: 5px; color: red; cursor: pointer;width: 33%;"
                        @click="show=!show">
                        <span>{{money}}</span><i class="van-badge__wrapper van-icon van-icon-arrow"></i>
                    </div>
                </div>
            </div>
            <div id="headerData" @click="showHis">
                <div class="issue"><span>{{issue}}</span></div>
                <div class="sscnum">
                    <ul id="pk10num" class="flex sscli">
                        <li v-for="(item,index) in qiuList" :key="index"
                            :style="{'background-color': (item.type?'red':''), 'line-height':currentTop+'px'}">
                            {{item.num}}
                        </li>
                    </ul>
                </div>
                <div class="time"><span>{{drawTime}}</span></div>
            </div>
            <div id="resultList" v-if="his">
                <div class="result" v-for="(item,index) in historyList" :key="index" v-html="item"></div>
            </div>

            <div class="aotuheight" style="height: 100%;"></div>
            <div class="msgcontent" :class="'game'+gname.gameType" style="top: 0px;padding-top: 64px;"
                :style="keys?(gname.gameType==28?' height: calc(100% - 240px);':' height: calc(100% - 213px);'): ' height: calc(100% - 56px);'"
                ref="scrollContainer" @scroll="handleScroll">
                <div v-for="(item,index) in msgcontent" :key="index">
                    <div class="msglayer" :class="item.rank==1?'msgright':'msgleft'">
                        <div class='fpop'
                            :class="user.NickName==item.wid||(item.content.includes(user.NickName)&&item.atUser == 'ck')?(item.atUser == 'ck'?'corr2 corr3':'corr3'):(item.atUser=='kai'||item.atUser=='kai2'||item.atUser=='kai3'||item.atUser=='kai4'||item.atUser=='kai5'||item.atUser=='kai6'?'corr2':(item.atUser == 'ck'?'corr2':''))">
                            <div class='headimg'>
                                <img :src="'https://' + host + '/static/xz/admin/jqr.png'"
                                    v-if="item.rank == 2 && !item.headimg" />
                                <img :src="'https://' + host + item.headimg" v-if="item.headimg" />
                            </div>
                            <h5 class='uname sys'>{{item.name}}</h5>
                            <div class='msg-loader' v-if="item.loading" style="display: none;">
                                <div class='throbber-loader' id='loading'>Loading…</div>
                            </div>
                            <div class='msgimg'
                                :style="((item.content.includes('ck')||item.content.includes('期数'))?'width: 100%;max-width: 100%;padding:0 5px;text-align:left;font-size: 16px;font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;color:#000;':'padding:0 5px;')"
                                v-if="item.type==2||item.atUser == 'kai' || item.atUser == 'kai2'"
                                v-html="item.content"></div>
                            <pre class='msgpre'
                                :style="((item.atUser == 'kai3' || item.atUser == 'kai4' || item.atUser == 'kai5') ? 'width:100%;max-width:100%;box-sizing: border-box;padding-right:6px;line-height: 18px;padding: 6px;margin: 0;box-sizing: border-box;font-variant-numeric: tabular-nums;' : (item.atUser == 'kai6' ? 'line-height: 18px;width:100%;max-width:100%;padding: 6px;margin: 0;box-sizing: border-box;' : ('font-variant-numeric: tabular-nums;'+(item.content.includes('累计') ? 'width:255px;' : '' ))))"
                                v-if="item.type==1&&!item.content.includes('wanfa')" v-html="item.content">
                            </pre>
                            <img :src="'https://' + host + item.content" style='max-width:96%;margin:5px auto;'
                                v-if="item.content.includes('wanfa')">
                            <p class="isvip"
                                style="width: 90%;margin: 5px auto;background: #07c160;color: #fff;text-align:center;line-height: 28px;border-radius: 5px;"
                                :style="(user.isVip == 1 ? 'display: block;' : 'display: none;')"
                                v-if="user.NickName==item.wid && item.type==1&&item.content.includes('流水')"
                                @click="checkOrder">查看详情
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divBottom msgdown" :class="keys?'selekb':''">
                <div style="background:#dadadc;width:100%;height:1px;position:absolute;top:0px;"></div>
                <div class="btndown" v-if="isScroll" @click="scrollToBottom()"><b>{{newMsgCount}}条新消息</b></div>
                <div class="divBottom_top">
                    <div class="vkb" @click="showKey">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                    <div style="width: 102px;text-align: center;background-color: rgb(255, 255, 255);height: 32px;padding-left: 0px;border-radius: 3px;border: 1px solid #07c160;color: #07c160;line-height: 32px;font-size: 14px;margin-left: 20px;"
                        @click="showQiu=true" v-if="gname.hasSelect&&actions.length>0">
                        第 {{qiuIndex}} 球
                    </div>
                    <textarea id="txtMsg" class="nostart" rows="1" autocomplete="off" ref="textScrop"
                        style="top: 0px; visibility: visible;width: 68%;overflow: auto;" v-model="txtmsg"
                        :style="gname.gameType==17?'margin-left:5px;':''"></textarea>
                    <span type="submit" class="send nostart" style="width: 96px;margin-left: 10px;"
                        @click="send">发送</span>
                </div>
                <div class="inpvkb" id="pc28Keyboard" v-if="gname.gameType==28">
                    <ul class="dw">
                        <li @click="clickBtn('查')">查</li>
                        <li @click="clickBtn('上')">上</li>
                        <li @click="clickBtn('下')">下</li>
                        <li @click="clickBtn('一')">一</li>
                        <li @click="clickBtn('二')">二</li>
                        <li @click="clickBtn('三')">三</li>
                        <li @click="clickBtn('四')">四</li>
                        <li @click="clickBtn('五')">五</li>
                        <li @click="clickBtn('定')">定</li>
                        <li class="del" @click="clickBtn('×')">×</li>
                    </ul>
                    <ul class="nb">
                        <li @click="clickBtn('前')">前</li>
                        <li @click="clickBtn('中')">中</li>
                        <li @click="clickBtn('后')">后</li>
                        <li @click="clickBtn('7')">7</li>
                        <li @click="clickBtn('8')">8</li>
                        <li @click="clickBtn('9')">9</li>
                        <li @click="clickBtn('去')">去</li>
                        <li @click="clickBtn('排')">排</li>
                        <li class="w2" @click="clickBtn('玩法')">玩法</li>
                    </ul>
                    <ul class="nb">
                        <li @click="clickBtn('单')">单</li>
                        <li @click="clickBtn('双')">双</li>
                        <li @click="clickBtn('全')">全</li>
                        <li @click="clickBtn('4')">4</li>
                        <li @click="clickBtn('5')">5</li>
                        <li @click="clickBtn('6')">6</li>
                        <li @click="clickBtn('头')">头</li>
                        <li @click="clickBtn('尾')">尾</li>
                        <li class="w2" @click="clickBtn('取消')">取消</li>
                    </ul>
                    <ul class="nb">
                        <li @click="clickBtn('大')">大</li>
                        <li @click="clickBtn('小')">小</li>
                        <li @click="clickBtn('百')">百</li>
                        <li @click="clickBtn('1')">1</li>
                        <li @click="clickBtn('2')">2</li>
                        <li @click="clickBtn('3')">3</li>
                        <li @click="clickBtn('-')">-</li>
                        <li @click="clickBtn('各')">各</li>
                        <li class="bspace w2" @click="clickBtn(' ')">&nbsp;</li>
                    </ul>
                    <ul class="fh">
                        <li @click="clickBtn('十')">十</li>
                        <li @click="clickBtn('个')">个</li>
                        <li @click="clickBtn('位')">位</li>
                        <li @click="clickBtn('0')">0</li>
                        <li @click="clickBtn('.')">.</li>
                        <li @click="clickBtn('/')">/</li>
                        <li @click="clickBtn('=')">=</li>
                        <li class="bspace" @click="clickBtn(' ')">&nbsp;</li>
                        <li class="nline w2" @click="clickBtn('nline')">换行</li>
                    </ul>
                </div>
                <div class="inpvkb" v-else>
                    <ul class="dw">
                        <li @click="clickBtn('查')">查</li>
                        <li @click="clickBtn('上')">上</li>
                        <li @click="clickBtn('下')">下</li>
                        <li @click="clickBtn('加')">加</li>
                        <li @click="clickBtn('无')">无</li>
                        <li @click="clickBtn('大')">大</li>
                        <li @click="clickBtn('小')">小</li>
                        <li @click="clickBtn('单')">单</li>
                        <li @click="clickBtn('双')">双</li>
                        <li @click="clickBtn('×')" class="del">×</li>
                    </ul>
                    <ul class="nb">
                        <li @click="clickBtn('番')">番</li>
                        <li @click="clickBtn('角')">角</li>
                        <li @click="clickBtn('车')">车</li>
                        <li @click="clickBtn('严')">严</li>
                        <li @click="clickBtn('正')">正</li>
                        <li @click="clickBtn('堂')">堂</li>
                        <li @click="clickBtn('通')">通</li>
                        <li @click="clickBtn('特')" v-if="gname.hasTe">特</li>
                        <li @click="clickBtn('念')" v-if="!gname.hasTe">念</li>
                        <li @click="clickBtn('取消')" class="w2">取消</li>
                    </ul>
                    <ul class="nb">
                        <li @click="clickBtn('1')">1</li>
                        <li @click="clickBtn('2')">2</li>
                        <li @click="clickBtn('3')">3</li>
                        <li @click="clickBtn('4')">4</li>
                        <li @click="clickBtn('5')">5</li>
                        <li @click="clickBtn('6')">6</li>
                        <li @click="clickBtn('7')">7</li>
                        <li @click="clickBtn('8')">8</li>
                        <li @click="clickBtn('9')">9</li>
                        <li @click="clickBtn('0')">0</li>
                    </ul>
                    <ul class="fh">
                        <li @click="clickBtn('+')">+</li>
                        <li @click="clickBtn('-')">-</li>
                        <li @click="clickBtn('/')">/</li>
                        <li @click="clickBtn('=')">=</li>
                        <li @click="clickBtn(',')">,</li>
                        <li @click="clickBtn('.')">.</li>
                        <li @click="clickBtn(' ')" class="bspace">&nbsp;</li>
                        <li @click="clickBtn('流水')" class="w2">流水</li>
                        <!-- <li @click="clickBtn('')" class="w2">大厅</li> -->
                        <li @click="clickBtn('nline')" class="nline">换</li>
                    </ul>
                </div>
            </div>

            <div id="shezhi" style="display:none;">
                <form class="layui-form" action="">
                    <div class="layui-form-item">
                        <div class="layui-input-block" style="margin-left: 40px;">
                            <input type="text" name="num" required value="" lay-verify="required" placeholder="请输入"
                                autocomplete="off" class="layui-input" style="width: 90%;">
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <div class="layui-input-block">
                            <button class="layui-btn" lay-submit lay-filter="formDemo">保存</button>
                        </div>
                    </div>
                </form>
            </div>

            <van-popup v-model="orderShow" closeable position="bottom" :style="{ height: '100%' }">
                <div id="content" style="height: 100%;padding-top: 46px;" v-if="load">
                    <div class="van-nav-bar van-nav-bar--fixed van-hairline--bottom">
                        <div class="van-nav-bar__content">
                            <div class="van-nav-bar__title van-ellipsis">用户流水（6点一天）</div>
                        </div>
                    </div>
                    <div style="background: #fff;">
                        <div style="width:100%;font-size:14px;height: 40px;background: #fff;line-height: 35px;">
                            <div class="dates" style="font-size:14px;display: flex;justify-content: space-around;">
                                <span id="day1" :class="index==recordIndex?'sele':''" v-for="(item,index) in time"
                                    :key="index" @click="selectTime(index)">{{item}}</span>
                            </div>
                        </div>
                        <div id="way1" style="width:100%;overflow: auto;height: 87vh;">
                            <div id="content" style="margin-top:5px;margin-bottom: 50px;" class="infolist"
                                v-loading="isLoad">
                                <div class="infoitem" v-for="(item,index) in recordList.detail" :key="index"
                                    @click="ShowMyChildren(item,index)" :class="item.chi==1?'chi':''">
                                    <el-collapse>
                                        <el-collapse-item>
                                            <template slot="title">
                                                <div class="item_top">会员ID：<span class="userid">@v{{item
                                        .BelongOperator}}</span>，昵称：<span class="nickname">{{item
                                        .NickName}}</span>，备注：<span class="nickname">{{item
                                        .remark}}</span></div>
                                                <div class="all_fanshui" style="display: none;">总返水：{{item
                                        .totalFanShui}}</div>
                                                <div class="profit_loss">昨余: {{item
                                        .ZuoYu}}，<!-- &nbsp;&nbsp; 流水: {{item
                                        .totalLiuShui}}， -->&nbsp;&nbsp; 双边流水: {{item
                                        .totalValidLiuShuis}}，&nbsp;&nbsp;单边流水: {{item
                                        .totalValidLiuShui}}，&nbsp;&nbsp; <br />盈亏: {{item
                                        .totalYingKui}},&nbsp;&nbsp;上下:&nbsp;&nbsp;{{item
                                        .totalUp+'-'+item.totalDown}}=&nbsp;&nbsp;{{item
                                        .totalUpDown}}
                                                    <div style="background: rgb(239, 239, 239); padding: 5px; border: 1px solid black;"
                                                        v-if="item.chi==1">
                                                        吃双边流水：{{item.totalValidLiuShuischi}}，吃单边流水：{{item.totalValidLiuShuichi}}，
                                                        <br>吃盈亏：<span>{{item.totalYingKuichi}}</span>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="item_detail">
                                                <div v-for="(vo, qihao) in item.list" :key="qihao">
                                                    <van-divider
                                                        :style="{ color: '#000', borderColor: '#888'}">{{qihao}}</van-divider>
                                                    <div v-for="(mingxi,key) in vo" :key="key">
                                                        <div v-if="mingxi.dttype==0" class="infoitem_row type2"
                                                            style="margin-top: 10px; margin-bottom: 10px;"><span
                                                                class="rowtype">积分操作：</span><span
                                                                class="rowqi"></span><span
                                                                class="rowcontent sf">{{isHas(mingxi.cmd,"转分上")?mingxi.dtNickName+'转分':'机器人'}}上分{{mingxi.score}}</span><br><span
                                                                class="rowresult" style="display: block;"></span><span
                                                                class="rowbefore"></span><span
                                                                class="rowchange win">+{{mingxi.score}}</span><span
                                                                class="fanshui"></span><span
                                                                class="rowscore">{{mingxi.afterScore}}</span><br><span
                                                                class="rowtime">{{mingxi.dtJieSuan}}</span></div>
                                                        <div v-if="mingxi.dttype==1" class="infoitem_row type2"
                                                            style="margin-top: 10px; margin-bottom: 10px;"><span
                                                                class="rowtype">积分操作：</span><span
                                                                class="rowqi"></span><span
                                                                class="rowcontent xf">{{isHas(mingxi.cmd,"转分下")?mingxi.dtNickName+'转分':'机器人'}}下分{{mingxi.count}}</span><br><span
                                                                class="rowresult" style="display: block;"></span><span
                                                                class="rowbefore"></span><span
                                                                class="rowchange lose">{{mingxi.count}}</span><span
                                                                class="fanshui"></span><span
                                                                class="rowscore">{{mingxi.afterScore}}</span><br><span
                                                                class="rowtime">{{mingxi.dtJieSuan}}</span></div>
                                                        <div v-if="mingxi.dttype==5&&mingxi.count>0"
                                                            class="infoitem_row type1" style="margin-top: 2px;"><span
                                                                class="rowtype">盈亏操作：</span><span
                                                                class="rowqi">{{mingxi.qihao}}</span><span
                                                                class="rowcontent">{{mingxi.cmdText}}</span><!-- <span
                                                            class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br> --><span
                                                                class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                                                class="rowbefore"></span><br /><span
                                                                class="rowchange win">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                                                class="fanshui" style="display: none;">[返水{{mingxi.dtfanshui}}]</span>&nbsp;&nbsp;<span
                                                                class="rowscore"
                                                                v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                                                class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                                            </span>
                                                            <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                                        </div>
                                                        <div v-if="mingxi.dttype==5&&mingxi.count==0"
                                                            class="infoitem_row type1" style="margin-top: 2px;"><span
                                                                class="rowtype">盈亏操作：</span><span
                                                                class="rowqi">{{mingxi.qihao}}</span><span
                                                                class="rowcontent">{{mingxi.cmdText}}</span><!-- <span
                                                            class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br> --><span
                                                                class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                                                class="rowbefore"></span><br /><span
                                                                class="rowchange win">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                                                class="fanshui" style="display: none;">{{mingxi.ying==1?'[返水' + mingxi.dtfanshui + ']':'[返水' + mingxi.dtfanshui + ']'}}</span>&nbsp;&nbsp;<span
                                                                class="rowscore"
                                                                v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                                                class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                                            </span>
                                                            <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                                        </div>
                                                        <div v-if="mingxi.dttype==5&&mingxi.count<0"
                                                            class="infoitem_row type1" style="margin-top: 2px;"><span
                                                                class="rowtype">盈亏操作：</span><span
                                                                class="rowqi">{{mingxi.qihao}}</span><span
                                                                class="rowcontent">{{mingxi.cmdText}}</span><!-- <span
                                                            class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br> --><span
                                                                class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                                                class="rowbefore"></span><br /><span
                                                                class="rowchange lose">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                                                class="fanshui" style="display: none;">{{mingxi.ying==1?'[返水' + mingxi.dtfanshui + ']':'[返水' + mingxi.dtfanshui + ']'}}</span>&nbsp;&nbsp;<span
                                                                class="rowscore"
                                                                v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                                                class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                                            </span>
                                                            <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>

            <van-dialog v-model="show" title="" show-cancel-button @confirm="apply()">
                <h3 style="text-align: center;margin: 10px 0;">申请转分</h3>
                <van-field v-model="money" label="可转积分" readonly />
                <van-field name="radio" label="可转游戏">
                    <template #input>
                        <van-radio-group v-model="radio" direction="horizontal">
                            <div v-for="(item,index) in game" :key="index">
                                <van-radio v-if="item.name!=gname.name" :name="item.gameType">{{item.name}}</van-radio>
                            </div>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field v-model="value" label="转移积分" type="number" placeholder="请输入积分" />
            </van-dialog>

            <van-action-sheet v-model="showQiu" :actions="actions" cancel-text="取消" description="选择球位"
                close-on-click-action @select="onSelect" />

        </div>
    </div>
    <div id="loader-wrapper" v-else>
        <div id="loader" v-if="!isToast"></div>
        <div class="loader-section section-left" v-if="!isToast"></div>
        <div class="loader-section section-right" v-if="!isToast"></div>
        <div class="load_title">{{title}}</div>
    </div>
</template>

<script>
    var ws = null,
        that = null,
        isShow = true,
        timer = null;
    import {
        checkData
    } from '@/api/home'
    export default {
        name: 'HomePage',
        data() {
            return {
                isDone: true,
                actions: [],
                load: true,
                title: '正在加载应用，请耐心等待',
                msgcontent: [],
                countNum: 0,
                firstNum: 0,
                host: this.$store.state.baseUrl,
                keys: false,
                txtmsg: '',
                user: {},
                qiuIndex: 8,
                qihao: '',
                m_drawTime: 0,
                flag: null,
                drawTime: '',
                issue: '',
                money: null,
                gname: '',
                showQiu: false,
                isScroll: false,
                newMsgCount: 0,
                isLoad: false,
                qiuList: [],
                his: false,
                historyList: [],
                currentTop: 21,
                show: false,
                value: '',
                radio: '',
                game: [],
                isToast: false,
                isShow: true,
                sendMsg: {},
                orderShow: false,
                time: [],
                recordIndex: 2,
                timeType: 1,
                recordList: []
            }
        },
        // 在创建组件实例后执行
        async created() {
            that = this;
            var uu = window.localStorage.getItem('token');
            const data = await checkData(uu, 888888);
            if (data.status == 200) {
                this.user = data.user;
                this.money = data['user']['score' + data['name']['gameType']];
                this.gname = data.name;
                this.game = data.game;
                this.time = data.time;
                this.radio = data.name['gameType'];
                if (data.name.hasSelect) {
                    this.qiuIndex = window.localStorage.getItem('qiuIndex') ?? 8;
                }
                that.load = true;
                var list = data.msg;
                that.msgcontent = list;
                if (list.length > 0) {
                    // that.countNum = list[list.length - 1]['ids'];
                    that.firstNum = list[0]['ids'];
                }
                if (!that.isScroll) {
                    that.scrollToBottom();
                } else {
                    that.newMsgCount += list.length;
                }
                that.m_drawTime = data.kj.kj.dtOpen;
                var code = data.kj.kj.Code.split(',');
                that.issue = code.length > 8 ? data.kj.kj.QiHao.slice(-3) : data.kj.kj.QiHao;
                that.updateTime();
                that.setQiu(data.kj.kj);
                that.setData(list);
                this.initWS();
            } else {
                this.title = data.message;
                this.isToast = true;
            }
            document.addEventListener('touchstart', function(event) {
                if (event.touches.length > 1) {
                    event.preventDefault(); // 阻止事件继续传播
                }
            }, false);
        },
        beforeDestroy() {
            isShow = false;
            // if (ws) {
            ws.close();
            // }
        },
        methods: {
            checkOrder() {
                this.recordList = [];
                this.orderShow = true;
                this.getList();
            },
            dalert(title) {
                this.$dialog.alert({
                    message: title,
                }).then(() => {
                    that.value = '';
                });
            },
            apply() {
                if (!this.value) {
                    this.dalert('请输入转移积分');
                } else if (this.value < 1) {
                    this.dalert('转分金额必须大于0');
                } else if (this.value > Number(this.user.score)) {
                    this.dalert('转移积分不能大于可用积分');
                } else {
                    ws.send(JSON.stringify({
                        "type": 'tran',
                        "wxid": this.user.wxid,
                        "from": this.gname.gameType,
                        "to": this.radio,
                        "count": this.value
                    }));
                    that.value = '';
                }
            },
            onSelect(item, index) {
                this.showQiu = false;
                this.qiuIndex = item.id;
                window.localStorage.setItem('qiuIndex', item.id);
            },
            handleScroll(event) {
                const scrollTop = event.target.scrollTop;
                if (scrollTop > 200) {
                    this.isLoad = false;
                }
                if ((scrollTop < 180) && !this.isLoad) {
                    this.isLoad = true;
                    this.getHisList();
                }
                const container = this.$refs.scrollContainer;
                if (container.scrollHeight - scrollTop - 10 <= container.clientHeight) {
                    this.isScroll = false;
                } else {
                    this.isScroll = true;
                }
            },
            getHisList() {
                ws.send(JSON.stringify({
                    "type": 'his',
                    "wxid": this.user.wxid,
                    "count": this.firstNum
                }));
            },
            setData(list) {
                var q = list.qiuOn == 1 ? (list.qiu ? list.qiu.split(',') : []) : [1, 2, 3, 4, 5, 6, 7, 8];
                that.actions = [];
                for (var i = 0; i < q.length; i++) {
                    that.actions.push({
                        name: '第' + q[i] + '球',
                        id: q[i]
                    });
                    if (list.qiuOn == 1) {
                        if (!q.includes(that.qiuIndex)) {
                            that.qiuIndex = q[0];
                        }
                    }
                }
            },
            setQiu(kj) {
                var c = kj.Code.split(','),
                    gameJs = that.gname.jsType;
                that.qiuList = [];
                for (var i = 0; i < c.length; i++) {
                    if (gameJs) {
                        var jsArr = gameJs.split(',');
                        if (jsArr.includes(String(i + 1))) {
                            that.qiuList.push({
                                num: c[i],
                                type: true
                            });
                        } else {
                            that.qiuList.push({
                                num: c[i],
                                type: false
                            });
                        }
                    } else {
                        if (i == c.length - 1) {
                            that.qiuList.push({
                                num: c[i],
                                type: true
                            });
                        } else {
                            that.qiuList.push({
                                num: c[i],
                                type: false
                            });
                        }
                    }
                }
            },
            initWS() {
                ws = new WebSocket("wss://" + this.host + "/ws6?uid=" + this.user.id);
                ws.onopen = function() {
                    // timer = setInterval(() => {
                    ws.send(JSON.stringify({
                        "type": 'getData'
                    }));
                    that.isDone = false;
                    // }, 1000);
                };
                ws.onmessage = function(event) {
                    var list = JSON.parse(event.data);
                    that.load = true;
                    that.isDone = true;
                    if (list['Message']) {
                        var uu = window.localStorage.getItem('userToken');
                        if (list.user.token != uu) {
                            that.isShow = false;
                            that.title = '无效的链接';
                            that.isToast = true;
                            that.load = false;
                            clearInterval(timer);
                            ws.close();
                        } else {
                            that.user = list.user;
                            that.qihao = list.qh;
                            that.m_drawTime = list.kj.dtOpen;
                            var code = list.kj.Code.split(',');
                            that.issue = code.length > 8 ? list.kj.QiHao.slice(-3) : list.kj.QiHao;
                            that.money = list.user.score;
                            that.updateTime();
                            that.setData(list);
                            that.setQiu(list.kj);
                            var list = list['Message'];
                            for (var k in list) {
                                var dt = list[k];
                                if (that.countNum == 0) {
                                    if (!list[k]['content'].includes("上分无效") && !list[k]['content'].includes(
                                            "下分无效")) {
                                        that.msgcontent.push(dt);
                                    }
                                } else {
                                    if (dt.rank == 2) {
                                        if (!list[k]['content'].includes("上分无效") && !list[k]['content'].includes(
                                                "下分无效")) {
                                            that.msgcontent.push(dt);
                                        }
                                    }
                                }
                            }
                            if (list.length > 0) {
                                // that.countNum = list[list.length - 1]['ids'];
                                // that.firstNum = list[0]['ids'];
                            }
                            if (!that.isScroll && list.length > 0) {
                                that.scrollToBottom();
                            } else {
                                that.newMsgCount += list.length;
                            }
                            setTimeout(() => {
                                ws.send(JSON.stringify({
                                    "type": 'getData'
                                }));
                                that.isDone = false;
                            }, 500);
                        }
                    } else {
                        var data = list.list;
                        if (list.type == 'his') {
                            var container = that.$refs.scrollContainer;
                            var sH = container.scrollHeight;
                            for (var k in data) {
                                var dt = data[k];
                                that.msgcontent.unshift(dt);
                                that.firstNum = dt.ids;
                            }
                            setTimeout(function() {
                                var container = that.$refs.scrollContainer;
                                container.scrollTop = container.scrollHeight - sH;
                            }, 5);
                        }
                        if (list.type == 'getHis') {
                            that.isLoad = false;
                            that.recordList = list.list;
                        } else if (list.type == 'getHisDtl') {
                            that.isLoad = false;
                            that.recordList.detail[that.recordDtlIndex]['list'] = list.list;
                        } else if (list.istId) {
                            that.msgcontent.push(list);
                            setTimeout(function() {
                                document.getElementById('loading').remove();
                                that.scrollToBottom();
                            }, 100);
                        } else {
                            that.historyList = [];
                            for (var k in data) {
                                var dt = data[k];
                                var code = dt.Code.split(','),
                                    html = '',
                                    gameJs = that.gname.jsType;
                                for (var i in code) {
                                    if (gameJs) {
                                        var jsArr = gameJs.split(',');
                                        if (jsArr.includes(String(Number(i) + 1))) {
                                            html += '<li style="background-color: red;">' + code[i] + '</li>';
                                        } else {
                                            html += '<li>' + code[i] + '</li>';
                                        }
                                    } else {
                                        if (i == code.length - 1) {
                                            html += '<li style="background-color: red;">' + code[i] + '</li>';
                                        } else {
                                            html += '<li>' + code[i] + '</li>';
                                        }
                                    }
                                }
                                var div = '<div class="issue"><span>' + dt.QiHao +
                                    '</span></div><div class="sscnum"><ul id="pk10num" class="flex sscli">' + html +
                                    '</ul></div><div class="time"><span>' + dt.dtOpen + '</span></div>';
                                if (k != 0) {
                                    that.historyList.push(div);
                                }
                            }
                        }
                    }
                };
                ws.onclose = function() {
                    // clearInterval(timer);
                    if (isShow) {
                        that.initWS();
                    }
                };
            },
            showKey() {
                this.keys = !this.keys;
                this.scrollToBottom();
            },
            clickBtn(text) {
                if (text == "×") {
                    this.txtmsg = ((this.txtmsg || "").replace(/[\S\s]$/, ""));
                } else if (text == "nline") {
                    this.txtmsg = (this.txtmsg + "\r\n");
                    setTimeout(function() {
                        const container2 = that.$refs.textScrop;
                        container2.scrollTop = 200000;
                    }, 50);
                } else if (text == "") {
                    this.$router.go(-1);
                } else if (text == "查" || text == "取消" || text == "玩法") {
                    this.txtmsg = text;
                } else {
                    this.txtmsg = (this.txtmsg + text);
                }
            },
            send() {
                var sendContent = this.txtmsg;
                if (/\S/.test(sendContent)) {
                    if (sendContent == '取消' || sendContent == '历史' || sendContent == '玩法' || sendContent == '流水' ||
                        sendContent == '查' || sendContent.indexOf("上") != -1 || sendContent.indexOf("下") != -1
                    ) {} else {
                        sendContent = sendContent.trim();
                        sendContent = sendContent.replace(/^,|,$/g, '');
                        var sendArr = sendContent.split(","),
                            sendArr2 = sendContent.split("\n"),
                            str = '',
                            qiu = this.getQiu();
                        if (sendContent.indexOf(",") != -1) {
                            for (var i = 0; i < sendArr.length; i++) {
                                var t = sendArr[i];
                                str += qiu + t + ','
                            }
                        } else {
                            for (var i = 0; i < sendArr2.length; i++) {
                                var t = sendArr2[i];
                                str += qiu + t + '\n'
                            }
                        }
                        sendContent = str.slice(0, -1);
                    }
                    var div = {
                        atUser: null,
                        content: sendContent,
                        headimg: this.user.imgName,
                        ids: 1160339,
                        name: this.user.NickName,
                        rank: 1,
                        type: 1,
                        wxid: this.user.wxid,
                        loading: true
                    }
                    this.msgcontent.push(div);
                    var text = {
                        "dluser": this.user.NickName,
                        "wxid": this.user.wxid,
                        "cmd": sendContent,
                        'qh': this.qihao,
                        'je': 0,
                        'qiuIndex': this.qiuIndex
                    };
                    ws.send(JSON.stringify(text));
                }
                this.txtmsg = '';
                this.scrollToBottom();
            },
            scrollToBottom() {
                this.$nextTick(() => {
                    const container = this.$refs.scrollContainer;
                    container.scrollTop = 20000000;
                    this.newMsgCount = 0;
                    setTimeout(function() {
                        that.isScroll = false;
                    }, 30);
                });
            },
            updateTime() {
                if (this.m_drawTime <= 0) {
                    this.flag = setInterval(function() {
                        if (that.m_drawTime > 0 && that.m_drawTime < 300) return;
                        that.currentTop += 1;
                        for (var i = 0; i < that.qiuList.length; i++) {
                            var kjnum = Math.round(Math.random() * 20);
                            that.qiuList[i].num = kjnum;
                        }
                        if (that.currentTop > 50) {
                            that.currentTop = 0;
                        }
                    }, 80);
                    this.drawTime = '开奖中';
                } else {
                    clearInterval(this.flag);
                    var h = parseInt(this.m_drawTime / 60);
                    var m = parseInt(this.m_drawTime % 60);
                    if (m >= 10) {
                        h = '0' + h.toString() + ':' + m.toString();
                    } else {
                        h = '0' + h.toString() + ':0' + m.toString();
                    }
                    this.drawTime = h;
                    that.currentTop = 21;
                }
            },
            getQiu() {
                var qiu = (this.gname.hasSelect ? this.qiuIndex + '球' : (this.gname.gameWf ? this.gname
                    .gameWf + '/' : ''));
                return qiu;
            },
            showHis() {
                this.his = !this.his;
                ws.send(JSON.stringify({
                    "type": 'history',
                    "wxid": this.user.wxid
                }));
            },
            isHas(str, text) {
                return str.toString().indexOf(text) !== -1 ? true : false;
            },
            GetWayData(type) {
                ws.send(JSON.stringify({
                    "type": type,
                    "day": this.time[this.recordIndex],
                    "timeType": this.timeType,
                    "gameType": this.gname.gameType
                }));
            },
            ShowMyChildren(item, index) {
                this.recordDtlIndex = index;
                this.isLoad = true;
                ws.send(JSON.stringify({
                    "type": 'getHisDtl',
                    "day": this.time[this.recordIndex],
                    "timeType": this.timeType,
                    "wxid": item.wxid,
                    "gameType": this.gname.gameType
                }));
            },
            selectTime(index) {
                if (this.recordIndex != index) {
                    this.recordIndex = index;
                    this.recordList = [];
                    this.updateR();
                }
            },
            updateR() {
                if (this.recordTyIndex == 2) {
                    this.GetWayData('getWay2');
                } else if (this.recordTyIndex == 3) {
                    this.GetWayData('getWay3');
                } else if (this.recordTyIndex == 4) {
                    this.GetWayData('getWay4');
                } else if (this.recordTyIndex == 5) {
                    this.GetWayData('getWay4');
                } else {
                    this.getList();
                }
            },
            getList() {
                this.isLoad = true;
                ws.send(JSON.stringify({
                    "type": 'getHis',
                    "day": this.time[this.recordIndex],
                    "timeType": this.timeType,
                    "gameType": this.gname.gameType
                }));
            }
        }
    }
</script>

<style>
    .table_title {
        text-align: center;
        background-color: #7030a0;
        color: #fff;
        display: none;
    }

    .flex_row {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -webkit-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
    }

    .zoushi .row_title .row_item {
        width: 45px;
        text-align: center;
        border-right: 1px solid #4f81bd;
    }

    .zoushi .row_title .row_item_2 {
        width: 96px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around;
    }

    .zoushi .row_title .row_item_4 {
        width: 50px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around;
    }

    .zoushi .row_title .row_item_3 {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around;
    }

    .s_item {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        text-align: center;
    }

    .border_right {
        border-right: 1px solid #ccc;
    }

    .background_1 {
        background-color: #3cf;
    }

    .border_bottom_1 {
        border-bottom: 0.5px solid #4f81bd;
    }

    .color_red {
        color: red;
    }

    table,
    table tr th,
    table tr td {
        /* font-size: 12px; */
        font-weight: 500;
        text-align: center;
    }

    table tr th {
        height: inherit;
        line-height: 22px;
        vertical-align: bottom;
        font-weight: bolder;
    }

    table thead tr th {
        padding: 0;
    }

    table thead tr th p {
        border-top: 1px solid #888;
    }

    .game75 table tr th,
    .game75 table tr td {
        font-size: 12px;
    }

    .game75 .haoma {
        height: auto;
    }

    table {
        width: 100%;
        min-height: 12px;
        line-height: 12px;
        text-align: center;
        border-collapse: collapse;
    }

    .xsl_bian {
        border-left: 2px solid #33CCFF;
    }

    .xsl_nei {
        border-left: 1px solid #eee;
    }
</style>
<style type="text/css">
    .body {
        font-size: 16px;
    }

    .Cmd {
        color: black;
        font-size: 16px;
        background-color: yellow;
    }

    .ToHide {
        display: none;
    }

    .ToShow {
        display: block;
    }

    .dates span {
        margin-left: 10px;
        cursor: pointer;
    }

    .dates span.sele {
        /* background: #000; */
        /* color: #fff; */
        /* padding: 0 8px; */
        /* border-radius: 5px; */
    }

    .infoitem {
        border-radius: 4px;
        border: 1px solid #000;
        background: #dff4ff;
        margin: 2px;
        padding: 5px;
    }

    .infoitem.sele {
        border: 2px solid orange;
    }

    .liu {
        border: 2px solid orange;
    }

    .infoitem.is_excep {
        background: red;
        color: #fff;
    }

    .infoitem.is_excep .infoitem_row {
        background: #fcc9c9 !important;
        color: #000000 !important;
    }

    .infoitem.is_excep .all_fanshui {
        color: #ffffff !important;
    }

    .infoitem.is_tuo {
        background: #b2b2de;
    }

    .infolist .item_top span {
        font-weight: bold;
        margin: 2px;
    }

    .infolist .infoitem_row {
        position: relative;
        padding: 5px;
        border-radius: 4px;
        border: 1px solid #000;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .infoitem_row.type1 {
        background: #efefef;
    }

    .infolist .infoitem_row span {
        margin-right: 3px;
    }

    .infolist .infoitem_row span.tuo {
        position: absolute;
        top: -3px;
        left: 67px;
        background: darkblue;
        display: block;
        width: 20px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent {
        padding: 2px;
        background: #808080;
        color: #fff;
        display: inline-block;
    }

    .infolist .infoitem_row .rowcontent.sf {
        background: red;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.xf {
        background: green;
        color: #fff;
    }

    .infolist .infoitem_row .fanshui {
        color: red;
        font-size: 14px;
    }

    .infolist .infoitem_row .rowchange.win {
        color: red;
    }

    .infolist .infoitem_row .rowchange.lose {
        color: green;
    }

    .infolist .infoitem_row .rowscore {
        font-weight: bold;
    }

    .infolist .profit_loss.changescore:before {
        content: '改分';
        color: #ffffff;
        background: red;
        font-weight: bold;
    }

    .infolist .all_fanshui {
        color: red;
        display: none;
        font-weight: bold;
    }

    .tt1 {
        margin-top: 5px;
        font-size: 16px;
    }

    .green {
        background-color: green !important;
    }

    .red {
        background-color: red !important;
    }

    body,
    html {
        background: none repeat scroll 0 0 #fff;
        user-select: none;
        webkit-user-select: none;
        font: initial;
    }

    * {
        -webkit-touch-callout: none;
        /*系统默认菜单被禁用*/
        -webkit-user-select: none;
        /*webkit浏览器*/
        user-select: none;
        touch-action: manipulation;
    }

    abbr,
    article,
    aside,
    blockquote,
    body,
    command,
    dd,
    details,
    div,
    dl,
    dt,
    fieldset,
    figcaption,
    figure,
    footer,
    form,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    header,
    hgroup,
    html,
    input,
    li,
    mark,
    meter,
    nav,
    ol,
    output,
    p,
    pre,
    progress,
    section,
    summary,
    time,
    ul {
        margin: 0;
        padding: 0
    }

    body:before {
        clear: both;
        content: ".";
        display: block;
        height: 0;
        visibility: hidden
    }

    body {
        cursor: default;
        min-height: 100%;
        color: #333;
        /* font: inherit !important; */
        /*font: 14px/21px "Lucida Grande", Lucida Sans Unicode, Helvetica, Arial, Verdana, sans-serif*/
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 16px;
    }

    a {
        text-decoration: none;
        color: #00c
    }

    a:hover {
        text-decoration: underline
    }

    a {
        outline: 0;
        blr: expression(this.onFocus=this.blur())
    }

    img {
        border: 0 none
    }

    form {
        display: inline
    }

    button,
    input,
    select,
    textarea {
        font-size: 100%
    }

    table {
        border-collapse: collapse;
        border-spacing: 0
    }

    .ck {
        width: 4%;
        text-align: center;
        display: inline-block;
    }

    .nameSet {
        width: 38px;
        display: inline-block;
    }

    .layout {
        margin: 0 auto
    }

    ol,
    ul {
        list-style: none outside none
    }

    .clear {
        clear: both
    }

    .clearer {
        font-size: 1px;
        line-height: 1px;
        margin: 0;
        padding: 0
    }

    .clearer,
    .clearfixli:after {
        clear: both;
        display: block;
        height: 0
    }

    .clearfixli:after {
        content: ".";
        visibility: hidden
    }

    .clearfixli {
        display: inline-block
    }

    .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden
    }

    .clearfix {
        display: inline-block
    }

    * html .clearfix,
    * html .clearfixli {
        height: 1%
    }

    .clearfix,
    .clearfixli {
        display: block
    }

    .clearfixli li {
        display: inline;
        float: left
    }

    .kaipan {
        background: #fff;
        /*width: 275px;*/
        box-sizing: border-box;
        max-width: 100%;
        height: auto;
        margin-bottom: 30px;
        padding-right: 3px;
        padding-left: 3px;
        margin-top: 5px;
        font-family: Times New Roman;
    }

    .kphead {
        display: flex;
        align-items: center;
        line-height: 5px;
        margin-top: 20px;
    }

    .kpone {
        font-size: 26px;
        color: red;
        /* font-weight: bolder; */
    }

    .di {
        font-size: 16px;
        margin-left: 15px;
        color: #000;
        /* font-weight: bolder; */
    }

    .kptwo {
        display: flex;
        align-items: end;
        margin: 0;
        position: relative;
        height: 50px;
    }

    .kptime {
        font-size: 20px;
        color: #000;
        /* font-weight: bolder; */
    }

    .kpfan {
        background: red;
        color: #fff;
        font-size: 25px;
        line-height: 58px;
        font-weight: bolder;
        width: 64px;
        text-align: center;
        margin-left: 0;
        position: absolute;
        right: 0;
    }

    .kai {
        text-align: left;
        display: flex;
        align-items: center;
        /* justify-content: space-around; */
        margin: 2px 0 0 0;
    }

    .kpqiu {
        border-radius: 50px;
        border: 1px solid #128ad4;
        width: 24px;
        height: 22px;
        display: inline-block;
        text-align: center;
        font-size: 20px;
        line-height: 23px;
        font-weight: bolder;
        margin-right: 7px;
        color: #222;
    }

    .kpqiu.color1,
    .kpqiu.color2,
    .kpqiu.color3,
    .kpqiu.color4 {
        /*border: none;*/
        /*line-height: 30px;*/
    }

    .kpqiu.qiuhong,
    .kpqiu.hong {
        border: 1px solid red;
    }

    .kpqiu.qiuhong.green75,
    .kpqiu.hong.green75,
    .haoma span.hong.green75 {
        border-color: #27bf00 !important;
    }

    .kpqiu.qiuhong.red75,
    .kpqiu.hong.red75,
    .haoma span.hong.red75 {
        border-color: #d84125 !important;
    }

    .kpqiu.qiuhong.blue75,
    .kpqiu.hong.blue75,
    .haoma span.hong.blue75 {
        border-color: #1d79ff !important;
    }

    .kpqiu.qiuhong.yellow75,
    .kpqiu.hong.yellow75,
    .haoma span.hong.yellow75 {
        border-color: #ffc400 !important;
        background-color: #ffc400 !important;
    }

    .numblueHead.g75 {
        border-color: #27bf00 !important;
        background-color: transparent !important;
        color: #000;
    }

    .numblueHead.r75 {
        border-color: #d84125 !important;
        background-color: transparent !important;
        color: #000;
    }

    .numblueHead.b75 {
        border-color: #1d79ff !important;
        background-color: transparent !important;
        color: #000;
    }

    .haoma span.hong.yellow75,
    .haoma span.hong.blue75,
    .haoma span.hong.green75,
    .haoma span.hong.red75,
    .haoma span.hong.nohong {
        width: 24px;
        height: 24px;
        line-height: 22px;
    }

    .kpqiu.qiuhong.nohong,
    .kpqiu.hong.nohong,
    .haoma span.hong.nohong {
        border: none !important;
        width: auto;
    }

    .tbhead {
        display: flex;
        justify-content: space-around;
        background: #3cb6e6;
        line-height: 28px;
        width: 100%;
    }

    .tbhead span {
        font-size: 14px;
        color: #fff;
        width: 30px;
    }

    .tbhead span:nth-child(3) {
        width: 153px;
        text-align: center;
    }

    .game28 .tbhead span:nth-child(3) {
        text-align: left;
    }

    .tbhead span:nth-child(4) {
        width: 50px;
    }

    .qihao {
        font-size: 12px;
        color: #565454;
        letter-spacing: -1px;
    }

    .shijian {
        font-size: 12px;
        color: #565454;
        letter-spacing: 0;
        margin-left: 1px;
    }

    .haoma {
        font-size: 24px;
        color: #222;
        /*display: flex;*/
        align-items: center;
        margin-left: 0px;
        height: 21px;
        width: 153px;
        text-align: center;
    }

    .haoma span {
        border-radius: 50px;
        border: 1px solid #159aec82;
        width: 24px;
        height: 24px;
        display: inline-block;
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        margin-right: 1px;
        color: #000;
        letter-spacing: 0;
        /* font-weight: bold; */
    }

    .haoma span.hong {
        border: 1px solid #df1515;
    }

    .card2 .list>div {
        line-height: 15px !important;
    }

    .three {
        font-size: 12px;
        color: #fff;
        display: flex;
        align-items: center;
        margin-left: 1px;
    }

    .lu td {
        border: 1px solid #666;
        background: #fff;
    }

    .colorfan {
        background: #ff3e41;
        width: 18px;
        height: 20px;
        display: block;
        line-height: 15px;
        text-align: center;
        border: 1px solid #555;
        font-weight: bolder;
    }

    .da {
        color: #222;
        margin-left: 5px;
        font-size: 12px;
        /*font-weight:300;*/
        /* font-family: inherit; */
    }

    .dan {
        color: #222;
        margin-left: 3px;
        font-size: 12px;
        /*font-weight:300;*/
        /* font-family: inherit; */
    }

    .color1 {
        background: #5d96ff !important;
    }

    .color2 {
        background: #3ec67c !important;
    }

    .color3 {
        background: #f7d400 !important;
    }

    .color4 {
        background: #ff3e41 !important;
    }

    .color5 {
        background: #fff;
        width: 100%;
        height: 100%;
        color: #000;
        font-size: 13px;
    }

    table {
        width: 100%;
    }

    th {
        font-size: 16px;
        padding: 2px;
        width: 18px;
        height: 18px;
    }

    /*tr{background:#eee;}*/
    table {
        border-color: #ddd;
    }

    td span {
        background: #fa4444;
        width: 22.2px;
        /* height: 19px; */
        font-size: 16px;
        display: block;
        line-height: 20px;
        text-align: center;
        /* border: 1px solid #555; */
        color: #fff;
        font-weight: bolder;
        /* margin: 1px auto; */
        /* font-family: inherit; */
    }

    .hasQiu td span {
        width: 29px;
    }

    .luzi {
        background: #fff;
        padding: 4px 0;
    }

    .luzi thead {
        background: #d3d3d3;
        border-color: #686666;
    }

    uni-button {
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding-left: 14px;
        padding-right: 14px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: center;
        text-decoration: none;
        line-height: 2.55555556;
        border-radius: 5px;
        -webkit-tap-highlight-color: transparent;
        overflow: hidden;
        color: #000;
        background-color: #f8f8f8;
        cursor: pointer
    }

    uni-input {
        display: block;
        font-size: 16px;
        line-height: 1.4em;
        height: 1.4em;
        min-height: 1.4em;
        overflow: hidden
    }

    .uni-popup-dialog {
        width: 360px;
        border-radius: 11px;
        background-color: #0e6ead
    }

    .uni-dialog-title {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 25px
    }

    .uni-dialog-title-text {
        font-size: 16px;
        font-weight: 500;
        color: #fff
    }

    .uni-dialog-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 10px 20px;
        background-color: #fff
    }

    .uni-dialog-content .chouma {
        width: 33px;
        height: 33px
    }

    .uni-dialog-content-text {
        font-size: 14px;
        color: #6c6c6c
    }

    .uni-dialog-button-group {
        display: flex;
        flex-direction: row;
        border-top-color: #f5f5f5;
        border-top-style: solid;
        border-top-width: 1px;
        background-color: #fff
    }

    .uni-dialog-button {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 45px
    }

    .uni-border-left {
        border-left-color: #f0f0f0;
        border-left-style: solid;
        border-left-width: 1px
    }

    .uni-dialog-button-text {
        font-size: 16px;
        color: #333
    }

    .uni-button-color {
        color: #007aff
    }

    .uni-dialog-input {
        flex: 1;
        font-size: 18px;
        border: 1px #eee solid;
        height: 40px;
        /*padding: 0 10px;*/
        border-radius: 5px;
        color: #000;
        font-weight: bolder
    }

    .uni-popup__success {
        color: #4cd964
    }

    .uni-popup__warn {
        color: #f0ad4e
    }

    .uni-popup__error {
        color: #dd524d
    }

    .uni-popup__info {
        color: #909399
    }

    .uni-issue-time {
        display: flex;
        padding: 10px;
        justify-content: space-between;
        background-color: #eaeaea
    }

    .uni-issue-time .msg {
        color: #6b6b6f
    }

    .uni-issue-time .time {
        color: red
    }

    .button-row {
        display: flex;
        padding: 10px;
        justify-content: space-between;
        background-color: #fff
    }

    .button-row .button-item {
        display: flex;
        flex-direction: column;
        align-items: center
    }

    .button-row .button-item .btn {
        margin-bottom: 5px;
        padding-left: 8px;
        padding-right: 8px;
        font-size: 15px
            /* 按钮样式 */
    }

    .button-row .button-item .selected {
        background-color: #009eff;
        /* 选中时的背景颜色 */
        color: #fff
            /* 选中时的文字颜色 */
    }

    .button-money {
        display: flex;
        padding: 10px;
        justify-content: space-between;
        background-color: #fff;
        align-items: center;
    }

    .button-money .chouma {
        width: 33px;
        height: 33px
    }

    .button-money .button-item {
        /*display: flex;*/
        flex-direction: column;
        align-items: center;
        padding-right: 5px;
        width: 20%;
    }

    .button-money .button-item .btn {
        margin-bottom: 5px;
        padding-left: 8px;
        padding-right: 8px;
        font-size: 15px;
        color: #1d1dd4;
        font-weight: bolder;
        /* 按钮样式 */
    }

    .grid-container {
        display: grid;
        grid-gap: 10px;
        /* 网格间距 */
        padding: 10px;
        /* 容器的内边距 */
        border: 1px solid #ccc;
        /* 容器的边框 */
        background-color: #fff
    }

    .grid-4 {
        grid-template-columns: repeat(4, 1fr)
            /* 创建4列的网格 */
    }

    .grid-6 {
        grid-template-columns: repeat(6, 1fr)
            /* 创建4列的网格 */
    }

    .grid-item {
        height: 35px;
        /* 格子的高度 */
        background-color: #f9f9f9;
        /* 未选中时的背景颜色 */
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ddd
            /* 格子的边框 */
    }

    .grid-item .gou {
        display: none;
    }

    .grid-item.selected {
        background-color: #009eff;
        /* 选中时的背景颜色 */
        color: #fff
            /* 选中时的文字颜色 */
    }

    .grid-item.selected .gou {
        display: block;
    }
</style>
<style type="text/css">
    .msgcontent .msgtime b,
    .msgcontent .msgover b,
    .msglayer .uname,
    .msglayer *,
    .divBottom .add,
    .divBottom .send {
        -webkit-touch-callout: none;
        /*系统默认菜单被禁用*/
        -webkit-user-select: none;
        /*webkit浏览器*/
        user-select: none;
    }

    .msgcontent .msgtime,
    .msgcontent .msgover {
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }

    .divBottom .vkb:before {
        content: '';
        position: absolute;
        width: 12px;
        height: 3px;
        left: 50%;
        top: 75%;
        margin-left: -6px;
        margin-top: -1px;
        border-radius: 2px;
        background: #686868;
    }

    .divBottom .vkb,
    .divBottom .add,
    .divBottom .send {
        cursor: pointer;
        /*position: absolute;*/
        right: 0px;
        bottom: 1px;
        display: block;
        vertical-align: bottom;
        margin: 0;
    }

    .divBottom .add {
        border: 1px solid #a7a7a9;
        right: 10px;
        box-sizing: border-box;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        font-weight: bold;
        color: #7f8085;
    }

    .divBottom .add:before {
        content: '';
        position: absolute;
        width: 16px;
        height: 2px;
        left: 50%;
        top: 50%;
        margin-left: -8px;
        margin-top: -1px;
        background: #7f8085;
    }

    .divBottom .add:after {
        content: '';
        position: absolute;
        width: 2px;
        height: 16px;
        left: 50%;
        top: 50%;
        margin-left: -1px;
        margin-top: -8px;
        background: #7f8085;
    }

    .divBottom .send {
        /*border: 1px solid #1f8b1b;*/
        right: 8px;
        width: 55px;
        height: 32px;
        border-radius: 2px;
        text-align: center;
        line-height: 32px;
        font-weight: bold;
        color: #ffffff;
        background: #07c160;
        font-size: 14px;
        margin-right: 5px;
    }

    .divMaska {
        display: block;
        position: absolute;
        top: 0px;
        left: 2px;
        background-color: red;
        color: white;
        font-size: 12px;
        z-index: 99999999;
    }

    .divMaskb {
        display: none;
    }

    .msgcontent .msgtime b,
    .msgcontent .msgover b {
        margin: 0 auto;
        font-weight: normal;
        background: #cecece;
        color: #ffffff;
        padding: 2px 5px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 12px;
    }

    .msglayer .uname.sys {
        color: red !important;
    }

    .msglayer .uname.black {
        color: #000 !important;
    }

    .msglayer:before,
    .msglayer:after {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
    }

    .msglayer:after {
        clear: both;
    }

    .msglayer {
        zoom: 1;
        position: relative;
    }

    .msglayer .msgimg {
        position: relative;
        zoom: 1;
        text-align: center;
        display: block;
        margin: 5px auto;
    }

    .msglayer .msgimg img {
        display: inline-block;
        max-width: 95%;
        margin: 0 auto;
    }

    .msglayer.msgleft .headimg,
    .msglayer.msgright .headimg {
        width: 48px;
        height: 48px;
        position: absolute;
        top: -18px;
        overflow: hidden;
        border-radius: 4px;
    }

    .msglayer .headimg:before {
        position: absolute;
        display: block;
        width: 48px;
        height: 48px;
        right: 0px;
        top: 0px;
        background-size: contain;
        content: "";
        z-index: 1;
    }

    .msglayer.msgleft .headimg img,
    .msglayer.msgright .headimg img {
        position: relative;
        z-index: 2;
        width: 48px;
        height: 48px;
        border-radius: 4px;
    }

    .msglayer.msgleft .uname,
    .msglayer.msgright .uname {
        position: absolute;
        font-size: 14px;
        top: -18px;
        color: #6f6f6f;
        font-weight: 100;
        white-space: nowrap;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        /*font-weight: 500;*/
    }

    .msglayer .fpop.corr {
        background: #eff0fe !important;
    }

    .msglayer .fpop.corr3 {
        background: #eff0fe !important;
    }

    .msglayer .fpop.corr:after {
        border-color: transparent #eff0fe transparent transparent !important
    }

    .msglayer .fpop.corrgm {
        background: red !important;
        color: #ffffff;
        border: 1px solid #000000 !important;
    }

    .msglayer .fpop.corrgm:after {
        border-color: transparent red transparent transparent !important
    }

    .msglayer .fpop.corrgm:before {
        border-color: transparent #000000 transparent transparent !important
    }

    .msglayer.qun .uname:before {
        display: inline;
        background: #6b9dc8;
        color: #fff;
        font-size: 8px;
        line-height: 10px;
        text-align: center;
        padding: 0 1px;
        margin-right: 2px;
        border-radius: 2px;
        content: "群";
    }

    .msglayer.msgleft .fpop {
        float: left;
        display: inline-block;
        max-width: 80%;
        min-width: 30px;
        min-height: 30px;
        width: auto;
        margin: 25px 0 0 68px;
        padding: 0px;
        border: 1px solid #d1d1d1;
        background: #ffffff;
        border-radius: 7px;
        position: relative;
    }

    .msglayer.msgleft .fpop:before,
    .msglayer.msgleft .fpop:after {
        display: block;
        content: '';
        width: 0;
        height: 0;
        font-size: 0;
        overflow: hidden;
        position: absolute;
    }

    .msglayer.msgleft .fpop:before {
        border-width: 8px;
        border-style: solid dashed dashed;
        border-color: transparent #d1d1d1 transparent transparent;
        left: -16px;
        top: 7px;
    }

    .msglayer.msgleft .fpop:after {
        border-width: 10px;
        border-style: solid dashed dashed;
        border-color: transparent #ffffff transparent transparent;
        left: -16px;
        top: 5px;
    }

    .msglayer.msgleft .headimg {
        left: -60px;
    }

    .msglayer.msgleft .uname {
        left: -0px;
    }

    .msglayer.msgright .fpop {
        float: right;
        display: inline-block;
        max-width: 65%;
        min-width: 30px;
        min-height: 30px;
        margin: 25px 68px 0 0;
        padding: 0px;
        border: 1px solid #84b559;
        background: #a1e85a;
        border-radius: 7px;
        position: relative;
        color: #253f0f;
    }

    .msglayer.msgright .fpop:before,
    .msglayer.msgright .fpop:after {
        display: block;
        content: '';
        width: 0;
        height: 0;
        font-size: 0;
        overflow: hidden;
        position: absolute;
    }

    .msglayer.msgright .fpop:before {
        border-width: 8px;
        border-style: solid dashed dashed;
        border-color: transparent transparent transparent #84b559;
        right: -16px;
        top: 7px;
    }

    .msglayer.msgright .fpop:after {
        border-width: 10px;
        border-style: solid dashed dashed;
        border-color: transparent transparent transparent #a1e85a;
        right: -16px;
        top: 5px;
    }

    .msglayer.msgright .headimg {
        right: -60px;
    }

    .msglayer.msgright .uname {
        right: -0px;
    }

    .msglayer pre.msgpre {
        position: relative;
        zoom: 1;
        margin: 6px;
        font-size: 16px;
        line-height: 18px;
        white-space: pre-wrap;
        word-wrap: break-word;
        -webkit-touch-callout: auto;
        /*系统默认菜单被禁用*/
        -webkit-user-select: text !important;
        /*webkit浏览器*/
        user-select: auto;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        /* font-weight: 500; */
        color: #000;
    }

    .font_big .msglayer pre.msgpre {
        font-size: 24px !important;
        line-height: 26px !important;
    }

    .font_medium .msglayer pre.msgpre {
        font-size: 20px !important;
        line-height: 22px !important;
    }

    .font_big .msgcontent .msgtime b,
    .font_big .msgcontent .msgover b {
        font-size: 20px !important;
        line-height: 22px !important;
    }

    .font_medium .msgcontent .msgtime b,
    .font_medium .msgcontent .msgover b {
        font-size: 16px !important;
        line-height: 18px !important;
    }

    .font_big .msglayer.msgleft .uname,
    .font_big .msglayer.msgright .uname {
        font-size: 16px !important;
        line-height: 18px !important;
    }

    .font_medium .msglayer.msgleft .uname,
    .font_medium .msglayer.msgright .uname {
        font-size: 14px !important;
        line-height: 16px !important;
    }

    .font_big .divBottom #txtMsg {
        font-size: 20px !important;
        line-height: 22px !important;
    }

    .font_medium .divBottom #txtMsg {
        font-size: 18px !important;
        line-height: 20px !important;
    }

    @-moz-keyframes throbber-loader {
        0% {
            background: #dde2e7;
        }

        10% {
            background: #6b9dc8;
        }

        40% {
            background: #dde2e7;
        }
    }

    @-webkit-keyframes throbber-loader {
        0% {
            background: #dde2e7;
        }

        10% {
            background: #6b9dc8;
        }

        40% {
            background: #dde2e7;
        }
    }

    @keyframes throbber-loader {
        0% {
            background: #dde2e7;
        }

        10% {
            background: #6b9dc8;
        }

        40% {
            background: #dde2e7;
        }
    }

    .throbber-loader:not(:required) {
        -moz-animation: throbber-loader 2000ms 300ms infinite ease-out;
        -webkit-animation: throbber-loader 2000ms 300ms infinite ease-out;
        animation: throbber-loader 2000ms 300ms infinite ease-out;
        background: #dde2e7;
        display: inline-block;
        position: relative;
        text-indent: -9999px;
        width: 8px;
        height: 16px;
        margin: 0 20px;
    }

    .throbber-loader:not(:required):before,
    .throbber-loader:not(:required):after {
        background: #dde2e7;
        content: '\x200B';
        display: inline-block;
        width: 8px;
        height: 16px;
        position: absolute;
        top: 0;
    }

    .throbber-loader:not(:required):before {
        -moz-animation: throbber-loader 2000ms 150ms infinite ease-out;
        -webkit-animation: throbber-loader 2000ms 150ms infinite ease-out;
        animation: throbber-loader 2000ms 150ms infinite ease-out;
        left: -15px;
    }

    .throbber-loader:not(:required):after {
        -moz-animation: throbber-loader 2000ms 450ms infinite ease-out;
        -webkit-animation: throbber-loader 2000ms 450ms infinite ease-out;
        animation: throbber-loader 2000ms 450ms infinite ease-out;
        right: -15px;
    }

    .msglayer .msg-loader {
        position: absolute;
        top: 50%;
        margin-top: -8px;
        left: -50px;
        display: inline-block;
    }

    *,
    body {
        margin: 0px;
        padding: 0px;
    }

    .clearfix:before,
    .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        zoom: 1;
    }

    body {
        background: #f5f5f7;
        overflow-y: hidden;
        position: relative;
    }

    .aotuheight {
        background: #f5f5f7;
    }

    .msgcontent {
        -webkit-box-sizing: border-box;
        position: absolute;
        top: 0px;
        width: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        z-index: 4;
        -webkit-overflow-scrolling: touch;
    }

    .msgcontent.hide div {
        opacity: 0;
    }

    .msgcontent.hide .msgload {
        visibility: visible !important;
        opacity: 100 !important;
    }

    .msgcontent .msgload {
        visibility: hidden;
        display: inline-block;
        position: fixed !important;
        top: 10px;
        left: 50%;
        margin-left: -8px !important;
        z-index: 5;
    }

    .msgcontent #debugout {
        display: none;
        position: fixed !important;
        top: 30px;
        left: 0;
        text-align: center;
        z-index: 5;
    }

    .divBottom {
        background: #f5f5f7;
        position: absolute;
        bottom: 0px;
        width: 100%;
        z-index: 5;
        -webkit-overflow-scrolling: touch;
    }

    .aaa {
        color: red;
    }

    .divBottom_top {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .divBottom .btndown {
        display: inline-block;
        position: absolute;
        height: 24px;
        line-height: 24px;
        right: 30px;
        border: 1px solid #e7e7e7;
        background: #ffffff;
        cursor: pointer;
        border-radius: 13px;
    }

    .divBottom.msgdown .btndown {
        top: -30px;
    }

    .divBottom.msgup .btndown {
        bottom: -30px;
    }

    .divBottom .btndown:before {
        position: absolute;
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-width: 7px;
        border-style: solid;
        border-color: #09bb07 transparent transparent transparent;
        left: 6px;
        top: 9px;
    }

    .divBottom .btndown b {
        line-height: 24px;
        color: #09bb07;
        margin: 3px 8px 3px 24px;
    }

    .divBottom #txtMsg {
        margin: 10px 5px 10px 15px;
        background: #fcfcfc;
        border: 1px solid #dcdcde;
        border-radius: 8px;
        visibility: hidden;
        resize: none;
        overflow: hidden;
        line-height: 22px;
        font-size: 16px;
        padding: 5px 8px;
        outline: none;
        display: block;
        user-select: text !important;
    }

    .divBottom .inpvkb {
        position: relative;
        /*height: 160px;*/
        background: #d0d3dc;
        padding-bottom: 10px;
        display: none;
    }

    .divBottom .inpvkb ul {
        padding-top: 5px;
        width: 96%;
        height: 30px;
        margin: 0 auto;
        user-select: none;
    }

    .divBottom .inpvkb ul li {
        cursor: pointer;
        width: 8%;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: 700;
        margin-left: 1%;
        margin-right: 1%;
        float: left;
        background: #fdffff;
        color: #000000;
        text-align: center;
        border-radius: 20%;
        user-select: none;
    }

    .divBottom .inpvkb ul li.w2 {
        width: 16%;
        margin-left: 2%;
        margin-right: 2%;
    }

    .divBottom .inpvkb ul li.del {
        color: red !important;
    }

    .divBottom .inpvkb ul li.nline {
        color: #7f8085 !important;
        background: orange !important;
    }

    .divBottom .inpvkb ul li:hover,
    .divBottom .inpvkb .bspace:hover:after {
        /*background: darkorange !important;*/
    }

    .divBottom.selekb .inpvkb {
        display: block !important;
    }

    .divBottom .inpvkb .bspace {
        position: relative;
    }

    .divBottom .inpvkb .bspace:before {
        content: '';
        position: absolute;
        width: 80%;
        height: 10px;
        left: 10%;
        bottom: 5px;
        border-radius: 2px;
        background: #7f8085;
    }

    .divBottom .inpvkb .bspace:after {
        content: '';
        position: absolute;
        width: 70%;
        height: 10px;
        left: 15%;
        bottom: 8px;
        border-radius: 2px;
        background: #fff;
    }

    .divBottom .vkb {
        cursor: pointer;
        position: relative;
        display: block;
        margin: 0;
        border: 3px solid #7d7d81;
        left: 10px;
        box-sizing: border-box;
        width: 32px;
        height: 30px;
        border-radius: 50%;
        font-weight: bold;
        color: #7f8085;
    }

    .divBottom.selekb .vkb {
        /*border: 1px solid darkorange !important;*/
    }

    .divBottom.selekb .vkb:before,
    .divBottom.selekb .vkb li,
    .divBottom.selekb .vkb li:before {
        /*background: chocolate !important;*/
    }

    .divBottom .vkb ul {
        margin-top: 6px;
        margin-left: 3px;
        width: 22px;
        height: 10px;
    }

    .divBottom .vkb ul li {
        position: relative;
        width: 4px;
        height: 4px;
        background: #686868;
        margin-right: 1px;
        float: left;
        border-radius: 2px;
    }

    .divBottom .vkb ul li:before {
        position: absolute;
        content: '';
        width: 4px;
        height: 4px;
        background: #686868;
        top: 5px;
        float: left;
        border-radius: 2px;
    }

    .divBottom .vkb ul:before,
    .divBottom .vkb ul:after {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
    }

    .divBottom .vkb ul:after {
        clear: both;
    }

    /*.kajianhao {*/
    /*	margin-top: 28;*/
    /*	display: block;*/
    /*}*/
    /*.kajianhao ul {*/
    /*	width: 100%;*/
    /*	overflow: hidden;*/
    /*	position: absolute;*/
    /*	z-index: 99999;*/
    /*background: #f5f5f7;*/
    /*	top: 0;*/
    /*	text-align: center;*/
    /*}*/
    /*.kajianhao ul li {*/
    /*	display: inline-block;*/
    /*	margin-right: 0px;*/
    /*	width: 25px;*/
    /*height: 30px;*/
    /*	line-height: 36px;*/
    /*	font-size: 16px;*/
    /*	text-align: center;*/
    /*	color: #fff;*/
    /*border-radius: 5px;*/
    /*box-sizing: border-box;*/
    /*-webkit-box-sizing: border-box;*/
    /*-moz-box-sizing: border-box;*/
    /*position: relative*/
    /*}*/
    /*.kajianhao ul li i {*/
    /*	position: absolute;*/
    /*	left: 1px*/
    /*}*/
    /*.kajianhao ul li img {*/
    /*	width: 20px*/
    /*}*/
    /*.kajianhao ul .numblue,*/
    /*.kajianhao ul .numred {*/
    /*	margin-right: 16px;*/
    /*	height: 16px;*/
    /*	width: 16px;*/
    /*	color: #fff*/
    /*}*/
    /*.kajianhao ul .li_after {*/
    /*	margin-right: 0*/
    /*}*/
    .numblueHead {
        width: 24px !important;
        height: 24px !important;
        line-height: 20px;
        overflow: hidden;
        border: 2px solid #0092dd;
        border-radius: 50%;
        text-align: center;
        color: #fafafa;
        background-color: #0092dd;
    }

    .jiahao {
        text-align: center;
        color: #000;
        width: 24px !important;
        height: 24px !important;
        line-height: 20px;
        overflow: hidden;
        border: 2px solid #f5f5f7 !important;
    }

    .longhu,
    .zonghe {
        border-radius: 50%;
        text-align: center;
        color: #000;
        width: 24px !important;
        height: 24px !important;
        line-height: 20px;
        overflow: hidden;
        border: 2px solid #ffc400 !important;
        background-color: #ffc400 !important;
    }

    .numblueHeadActive {
        background-color: #f1010a !important;
        border: 2px solid #f1010a !important;
    }

    .divBottom .inpvkb ul {
        /*width: 100%;*/
        height: 35px;
        position: relative;
    }

    .table tbody tr:last-child td,
    .table tbody tr:last-child th {
        width: 36px;
        margin-bottom: 0;
        display: inline-block;
    }

    @media all and (min-width: 620px) {

        .msglayer .fpop.corr,
        .msglayer .fpop.corr2 {
            width: 55% !important;
            max-width: 90% !important;
        }

        .msgimg {
            width: 100% !important;
        }

        .ck {
            width: 4%;
        }

        td span {
            /* width: 32px; */
            /* height: 32px; */
            font-size: 22px;
            line-height: 30px;
            /* border: 2px solid #000; */
            /* margin: 2px auto; */
        }

        thead th {
            font-size: 20px;
            line-height: 15px;
        }

        .colorfan {
            width: 26px;
            height: 26px;
            line-height: 24px;
            border: 1px solid #000;
            font-size: 18px;
            margin: 1px 0;
        }

        .shijian,
        .qihao {
            font-size: 14px;
            color: #222;
            letter-spacing: 0px;
        }

        .da,
        .dan {
            margin-left: 6px;
            font-size: 15px;
            font-weight: bolder;
        }

        .kai {
            /* margin: 16px 0; */
        }

        .kpqiu {
            /* border: 3px solid #128ad4; */
            width: 46px;
            height: 46px;
            font-size: 24px;
            line-height: 40px;
        }

        .kpqiu.qiuhong,
        .kpqiu.hong {
            border: 3px solid red;
        }

        .kptime {
            font-size: 24px;
        }

        .kpfan {
            font-size: 50px;
            line-height: 88px;
            width: 110px;
            position: inherit;
        }

        .kaipan {
            width: 100%;
        }

        .kpone {
            font-size: 34px;
            margin-left: 16px;
        }

        .di {
            font-size: 20px;
        }

        .kptwo {
            height: 95px;
            justify-content: space-between;
            padding: 0 18px;
        }
    }

    @media all and (max-width: 320px) {
        .ck {
            width: 4% !important;
        }
    }

    @media all and (max-width: 620px) {

        /*.kpqiu {*/
        /*width: 16px;height: 16px;font-size: 14px;line-height: 16px;*/
        /*}*/
        /*td span {*/
        /*    width: 12px;*/
        /*    height: 14px;*/
        /*    line-height: 14px;*/
        /*}*/
        .tbhead span {
            font-size: 13px;
        }

        .msglayer pre.msgpre {
            /* font-size: 15px; */
        }

        .di {
            font-size: 16px;
            margin-left: 10px;
        }

        .kpone {
            font-size: 26px;
        }

        .msglayer.msgleft .fpop {
            max-width: 290px !important;
            margin: 25px 0 0 68px !important;
        }

        .msglayer .fpop.corr,
        .msglayer .fpop.corr2 {
            width: 290px !important;
        }

        .msgimg {
            width: 100% !important;
        }

        .kpfan {
            right: 36px;
            width: 42px;
            line-height: 40px;
            /*font-size: 28px;*/
        }

        .kptime {
            font-size: 16px;
        }

        .ck {
            width: 4%;
        }

        .msglayer.msgleft .headimg {
            left: -60px !important;
        }

        .msglayer.msgleft .headimg,
        .msglayer.msgright .headimg {
            width: 48px !important;
            height: 48px !important;
            /* top: -10px !important; */
        }

        .msglayer.msgleft .headimg img,
        .msglayer.msgright .headimg img {
            width: 48px !important;
            height: 48px !important;
        }

        .numblueHead {
            width: 24px !important;
            height: 24px !important;
            line-height: 20px;
        }

        .table tbody tr:last-child td,
        .table tbody tr:last-child th {
            width: 26px;
        }

        .haoma span {
            width: 18px;
            height: 18px;
            font-size: 12px;
            line-height: 18px;
        }

        .game103 .haoma span,
        .game50 .haoma span {
            width: 16px;
            height: 16px;
            font-size: 11px;
            line-height: 15px;
        }

        .game103 .kpqiu,
        .game50 .kpqiu {
            width: 22px;
            height: 20px;
            font-size: 17px;
            line-height: 19px;
            margin-right: 3px;
        }

        .game103 .haoma,
        .game50 .haoma {
            width: auto;
            text-align: center;
            line-height: 12px;
        }
    }

    .float-rigth {
        position: fixed;
        right: 0;
        top: 65%;
        transform: translateY(-50%);
        z-index: 100;
    }

    .float-box {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ccc;
        border-radius: 20px 0 0 20px;
        box-shadow: 0 2px 5px rgb(0 0 0 / 20%);
        width: 66px;
        padding-right: 10px;
        margin-bottom: 20px;
        font-size: 12px;
        font-weight: bolder;
        color: #000;
    }

    .float-rigth img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-left: 1px;
        background-color: #fff;
        padding: 5px;
        border: 2px solid #ccc;
    }

    .color-red {
        color: red
    }

    .page-session {
        display: flex;
        flex-direction: column;
        padding-bottom: env(safe-area-inset-bottom);
        box-sizing: border-box;
        height: 100%
    }

    .top_bar {
        background-color: #fffed8;
        font-size: 13px;
        z-index: 10;
        position: fixed;
        width: 100%;
        color: #000;
        top: 32px;
    }

    .top_bar .row {
        display: flex;
        justify-content: space-between;
        margin-left: 3px
    }

    .top_bar .column {
        text-align: left;
        /* 文本居中 */
        margin: 3px;
        /* 列之间的间距 */
        font-weight: 420;
        padding: 0;
    }

    .top_bar .column_k3 {
        padding: 0 20px
    }

    .top_bar .blue {
        color: #00f;
        font-weight: bolder
    }

    .zoushitu {
        border: 1px solid #7030a0;
        font-size: 13px;
        left: 0;
        /*top: 123px;*/
        width: 100%;
        background-color: #fff
    }

    .zoushitu .table_title {
        text-align: center;
        background-color: #7030a0;
        color: #fff
    }

    .zoushitu .table_title .row_title .row_item {
        width: 48px;
        text-align: center;
        border-right: 1px solid #4f81bd
    }

    .zoushitu .table_title .row_title .row_item_4 {
        width: 50px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around
    }

    .zoushitu .table_title .row_title .row_item_3 {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around
    }

    .zoushitu .scroll_view .row_title .row_item {
        font-size: 11px;
        font-weight: 450;
        width: 48px;
        text-align: center;
        border-right: 2px solid #00f
    }

    .zoushitu .scroll_view .row_title .row_item .s_item {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        text-align: center
    }

    .zoushitu .scroll_view .row_title .row_item .background-image {
        width: 100%;
        /* 定义背景图片的宽度，例如全屏 */
        height: 25px;
        /* 定义背景图片的高度 */
        /* background-image: url(/static/play/ball_hk6.png); */
        /* 设置背景图片的路径 */
        background-size: cover;
        /* 背景图片覆盖整个元素，保持图片的宽高比 */
        margin-top: 4px
    }

    .zoushitu .scroll_view .row_title .row_item .b01 {
        background-position: 0 0
    }

    .zoushitu .scroll_view .row_title .row_item .b02 {
        background-position: 0 -23px
    }

    .zoushitu .scroll_view .row_title .row_item .b03 {
        background-position: 0 -49px
    }

    .zoushitu .scroll_view .row_title .row_item .b04 {
        background-position: 0 -73px
    }

    .zoushitu .scroll_view .row_title .row_item .b05 {
        background-position: 0 -98px
    }

    .zoushitu .scroll_view .row_title .row_item .b06 {
        background-position: 0 -123px
    }

    .zoushitu .scroll_view .row_title .row_item .circle {
        width: 20px;
        /* 圆的宽度 */
        height: 20px;
        /* 圆的高度 */
        border-radius: 50%;
        /* 使边框成圆形 */
        border: 1px solid #000;
        /* 边框样式 */
        display: flex;
        justify-content: center;
        align-items: center
    }

    .zoushitu .scroll_view .row_title .row_item .row_item_4 {
        width: 50px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around
    }

    .zoushitu .scroll_view .row_title .row_item .row_item_3 {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around
    }

    .zoushitu .scroll_view .row_title .row_item .border_right {
        border-right: 1px solid #ccc
    }

    .zoushitu .scroll_view .row_title .row_item .color_red {
        color: red
    }

    .zoushitu .scroll_view .row_title .row_k3 {
        min-width: 70px;
        font-size: 13px
    }

    .zoushitu .scroll_view .row_title .item_k3 {
        font-size: 13px
    }

    .zoushitu .scroll_view .flex_row {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -webkit-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between
    }

    .zoushitu .scroll_view .border_bottom_2 {
        border-bottom: .5px solid #ccc
    }

    .zoushitu .scroll_view .bg_baozi {
        background-color: #d6ff2a
    }

    .zoushitu .background_1 {
        background-color: #3cf
    }

    .zoushitu .border_bottom_1 {
        border-bottom: .5px solid #4f81bd
    }

    .zoushitu .flex_row {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -webkit-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between
    }

    .rule .title {
        font-size: 13px;
        text-align: center;
        background-color: #7030a0;
        color: #fff
    }

    .rule .content {
        font-size: 10px;
        background-color: #3cf;
        border-bottom: .5px solid #4f81bd
    }

    .orders {
        border: 1px solid #7030a0;
        font-size: 13px;
        left: 0;
        top: 109px;
        width: 100%;
        height: 300px;
        background-color: #fff
    }

    .orders .table_title {
        text-align: center;
        background-color: #7030a0;
        color: #fff
    }

    .orders .table_title .page {
        padding-left: 15px;
        padding-right: 15px;
        color: #0ff
    }

    .orders .row_title .row_item_1 {
        width: 40px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        -webkit-justify-content: space-around;
        justify-content: space-around;
        flex: auto
    }

    .orders .row_title .row_item {
        width: 90px;
        text-align: center;
        border-right: 1px solid #4f81bd;
        flex: auto
    }

    .orders .background_1 {
        background-color: #3cf
    }

    .orders .border_bottom_1 {
        border-bottom: .5px solid #4f81bd
    }

    .orders .flex_row {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -webkit-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between
    }

    .page-session .container {
        position: fixed;
        right: 0;
        top: 50%;
        /* Adjust as needed */
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1000
            /* Ensure it's above other content */
    }

    .page-session .container .floating-button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        /* Space between buttons */
        background-color: #ccc;
        border-radius: 20px 0 0 20px;
        /* Half circle on the left side */
        box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
        /* Optional shadow */
        width: 55px;
        /* Width of the button */
        padding-right: 10px;
        /* Padding inside the button */
        margin-bottom: 20px
    }

    .page-session .container .floating-button .icon {
        width: 14px;
        /* Icon size */
        height: 14px;
        /* Icon size */
        border-radius: 50%;
        /* Make it round */
        margin-left: 1px;
        /* Half outside the button */
        background-color: #fff;
        /* Icon background */
        padding: 5px;
        border: 2px solid #ccc
    }

    .page-session .container .floating-button .text {
        flex-grow: 1;
        text-align: center;
        font-weight: bolder
    }

    .page-session .container .kefu {
        font-size: 12px
    }

    .page-session .container .clear {
        font-size: 12px
    }

    .page-session .container .kefu_k3 {
        font-size: 14px;
        width: 60px;
        padding-right: 8px
    }

    .page-session .message-list {
        flex: 1;
        overflow: hidden;
        background-color: #f7f7f7;
        position: relative
    }

    .page-session .message-list .loadmore {
        margin: 5px 0
    }

    .page-session .message-list .scroller {
        height: 100%
    }

    .page-session .message-list .cl-popup__wrapper {
        position: absolute
    }

    .page-session .opbar {
        flex-shrink: 0;
        z-index: 9;
        background-color: #fff;
        border-top: 1px solid #f7f7f7
    }

    .page-session .opbar .main {
        display: flex;
        align-items: center;
        height: 50px
    }

    .page-session .opbar .main .icon {
        height: 40px;
        width: 40px;
        line-height: 40px;
        text-align: center;
        flex-shrink: 0
    }

    .page-session .opbar .main .icon .chat-iconfont {
        font-size: 30px
    }

    .page-session .opbar .main .input {
        flex: 1;
        margin: 0 5px;
        height: 35px;
        line-height: 35px
    }

    .page-session .opbar .main .input .cl-input .cl-input__wrap .cl-input__inner {
        font-size: 20px;
        color: red
    }

    .page-session .opbar .main .input .press-btn {
        display: inline-block;
        height: 35px;
        width: 100%;
        line-height: 35px;
        color: #666;
        border: 1px solid #dcdfe6;
        font-size: 12px;
        background-color: #fff;
        margin: 0;
        border-radius: 35px;
        box-sizing: border-box
    }

    .page-session .opbar .main .input .press-btn::after {
        border: 0
    }

    .page-session .opbar .main .input .press-btn:active {
        background-color: #f7f7f7
    }

    .page-session .popup-voice {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px
    }

    .page-session .popup-voice.is-cancel {
        background-color: red;
        color: #fff
    }

    .page-session .popup-voice__time {
        font-size: 14px;
        margin-bottom: 10px;
        letter-spacing: 1px
    }

    .page-session .popup-voice__desc {
        font-size: 12px
    }

    .orders,
    .rule,
    .zoushitu {
        display: none;
        position: fixed;
        top: 103px;
        z-index: 10;
        background: #fff;
    }

    .rule p {
        margin: 0 !important;
    }

    .blueQiu {
        height: 20px;
        width: 20px;
        line-height: 20px;
        border-radius: 50%;
        background: #5d96ff;
        color: #fff;
        float: left;
        text-align: center;
        /*margin-top: 5px;*/
        margin-left: 2px;
        font-size: 12px;
        display: none;
    }

    .redQiu {
        height: 20px;
        width: 20px;
        line-height: 20px;
        border-radius: 50%;
        float: left;
        background: #ff3e41;
        color: #fff;
        text-align: center;
        /*margin-top: 5px;*/
        margin-left: 2px;
        font-size: 12px;
    }

    .historyList .blueQiu,
    .historyList .redQiu {
        height: 20px;
        width: 20px;
        line-height: 20px !important;
        font-size: 12px;
    }

    @font-face {
        font-family: 'uniicons';
        /* 定义字体名称 */
        /* src: url('__STATIC__/xz/fonts/uniicons.b6d3756e.ttf'); */
        /* IE9 Compat Modes */
        /* src: url('__STATIC__/xz/fonts/uniicons.b6d3756e.ttf?#iefix') format('embedded-opentype'), */
        /* IE6-IE8 */
        /* url('__STATIC__/xz/fonts/uniicons.b6d3756e.ttf') format('woff2'), */
        /* Super Modern Browsers */
        /* url('__STATIC__/xz/fonts/uniicons.b6d3756e.ttf') format('woff'), */
        /* Pretty Modern Browsers */
        /* url('__STATIC__/xz/fonts/uniicons.b6d3756e.ttf') format('truetype'), */
        /* Safari, Android, iOS */
        /* url('webfont.svg#svgFontName') format('svg'); */
        /* Legacy iOS */
    }

    .uni-icons {
        font-family: uniicons;
        text-decoration: none;
        text-align: center;
    }

    .uniui-color:before {
        content: "\e6cf"
    }

    .uniui-wallet:before {
        content: "\e6b1"
    }

    .uniui-settings-filled:before {
        content: "\e6ce"
    }

    .uniui-auth-filled:before {
        content: "\e6cc"
    }

    .uniui-shop-filled:before {
        content: "\e6cd"
    }

    .uniui-staff-filled:before {
        content: "\e6cb"
    }

    .uniui-vip-filled:before {
        content: "\e6c6"
    }

    .uniui-plus-filled:before {
        content: "\e6c7"
    }

    .uniui-folder-add-filled:before {
        content: "\e6c8"
    }

    .uniui-color-filled:before {
        content: "\e6c9"
    }

    .uniui-tune-filled:before {
        content: "\e6ca"
    }

    .uniui-calendar-filled:before {
        content: "\e6c0"
    }

    .uniui-notification-filled:before {
        content: "\e6c1"
    }

    .uniui-wallet-filled:before {
        content: "\e6c2"
    }

    .uniui-medal-filled:before {
        content: "\e6c3"
    }

    .uniui-gift-filled:before {
        content: "\e6c4"
    }

    .uniui-fire-filled:before {
        content: "\e6c5"
    }

    .uniui-refreshempty:before {
        content: "\e6bf"
    }

    .uniui-location-filled:before {
        content: "\e6af"
    }

    .uniui-person-filled:before {
        content: "\e69d"
    }

    .uniui-personadd-filled:before {
        content: "\e698"
    }

    .uniui-back:before {
        content: "\e6b9"
    }

    .uniui-forward:before {
        content: "\e6ba"
    }

    .uniui-arrow-right:before {
        content: "\e6bb"
    }

    .uniui-arrowthinright:before {
        content: "\e6bb"
    }

    .uniui-arrow-left:before {
        content: "\e6bc"
    }

    .uniui-arrowthinleft:before {
        content: "\e6bc"
    }

    .uniui-arrow-up:before {
        content: "\e6bd"
    }

    .uniui-arrowthinup:before {
        content: "\e6bd"
    }

    .uniui-arrow-down:before {
        content: "\e6be"
    }

    .uniui-arrowthindown:before {
        content: "\e6be"
    }

    .uniui-bottom:before {
        content: "\e6b8"
    }

    .uniui-arrowdown:before {
        content: "\e6b8"
    }

    .uniui-right:before {
        content: "\e6b5"
    }

    .uniui-arrowright:before {
        content: "\e6b5"
    }

    .uniui-top:before {
        content: "\e6b6"
    }

    .uniui-arrowup:before {
        content: "\e6b6"
    }

    .uniui-left:before {
        content: "\e6b7"
    }

    .uniui-arrowleft:before {
        content: "\e6b7"
    }

    .uniui-eye:before {
        content: "\e651"
    }

    .uniui-eye-filled:before {
        content: "\e66a"
    }

    .uniui-eye-slash:before {
        content: "\e6b3"
    }

    .uniui-eye-slash-filled:before {
        content: "\e6b4"
    }

    .uniui-info-filled:before {
        content: "\e649"
    }

    .uniui-reload:before {
        content: "\e6b2"
    }

    .uniui-micoff-filled:before {
        content: "\e6b0"
    }

    .uniui-map-pin-ellipse:before {
        content: "\e6ac"
    }

    .uniui-map-pin:before {
        content: "\e6ad"
    }

    .uniui-location:before {
        content: "\e6ae"
    }

    .uniui-starhalf:before {
        content: "\e683"
    }

    .uniui-star:before {
        content: "\e688"
    }

    .uniui-star-filled:before {
        content: "\e68f"
    }

    .uniui-calendar:before {
        content: "\e6a0"
    }

    .uniui-fire:before {
        content: "\e6a1"
    }

    .uniui-medal:before {
        content: "\e6a2"
    }

    .uniui-font:before {
        content: "\e6a3"
    }

    .uniui-gift:before {
        content: "\e6a4"
    }

    .uniui-link:before {
        content: "\e6a5"
    }

    .uniui-notification:before {
        content: "\e6a6"
    }

    .uniui-staff:before {
        content: "\e6a7"
    }

    .uniui-vip:before {
        content: "\e6a8"
    }

    .uniui-folder-add:before {
        content: "\e6a9"
    }

    .uniui-tune:before {
        content: "\e6aa"
    }

    .uniui-auth:before {
        content: "\e6ab"
    }

    .uniui-person:before {
        content: "\e699"
    }

    .uniui-email-filled:before {
        content: "\e69a"
    }

    .uniui-phone-filled:before {
        content: "\e69b"
    }

    .uniui-phone:before {
        content: "\e69c"
    }

    .uniui-email:before {
        content: "\e69e"
    }

    .uniui-personadd:before {
        content: "\e69f"
    }

    .uniui-chatboxes-filled:before {
        content: "\e692"
    }

    .uniui-contact:before {
        content: "\e693"
    }

    .uniui-chatbubble-filled:before {
        content: "\e694"
    }

    .uniui-contact-filled:before {
        content: "\e695"
    }

    .uniui-chatboxes:before {
        content: "\e696"
    }

    .uniui-chatbubble:before {
        content: "\e697"
    }

    .uniui-upload-filled:before {
        content: "\e68e"
    }

    .uniui-upload:before {
        content: "\e690"
    }

    .uniui-weixin:before {
        content: "\e691"
    }

    .uniui-compose:before {
        content: "\e67f"
    }

    .uniui-qq:before {
        content: "\e680"
    }

    .uniui-download-filled:before {
        content: "\e681"
    }

    .uniui-pyq:before {
        content: "\e682"
    }

    .uniui-sound:before {
        content: "\e684"
    }

    .uniui-trash-filled:before {
        content: "\e685"
    }

    .uniui-sound-filled:before {
        content: "\e686"
    }

    .uniui-trash:before {
        content: "\e687"
    }

    .uniui-videocam-filled:before {
        content: "\e689"
    }

    .uniui-spinner-cycle:before {
        content: "\e68a"
    }

    .uniui-weibo:before {
        content: "\e68b"
    }

    .uniui-videocam:before {
        content: "\e68c"
    }

    .uniui-download:before {
        content: "\e68d"
    }

    .uniui-help:before {
        content: "\e679"
    }

    .uniui-navigate-filled:before {
        content: "\e67a"
    }

    .uniui-plusempty:before {
        content: "\e67b"
    }

    .uniui-smallcircle:before {
        content: "\e67c"
    }

    .uniui-minus-filled:before {
        content: "\e67d"
    }

    .uniui-micoff:before {
        content: "\e67e"
    }

    .uniui-closeempty:before {
        content: "\e66c"
    }

    .uniui-clear:before {
        content: "\e66d"
    }

    .uniui-navigate:before {
        content: "\e66e"
    }

    .uniui-minus:before {
        content: "\e66f"
    }

    .uniui-image:before {
        content: "\e670"
    }

    .uniui-mic:before {
        content: "\e671"
    }

    .uniui-paperplane:before {
        content: "\e672"
    }

    .uniui-close:before {
        content: "\e673"
    }

    .uniui-help-filled:before {
        content: "\e674"
    }

    .uniui-paperplane-filled:before {
        content: "\e675"
    }

    .uniui-plus:before {
        content: "\e676"
    }

    .uniui-mic-filled:before {
        content: "\e677"
    }

    .uniui-image-filled:before {
        content: "\e678"
    }

    .uniui-locked-filled:before {
        content: "\e668"
    }

    .uniui-info:before {
        content: "\e669"
    }

    .uniui-locked:before {
        content: "\e66b"
    }

    .uniui-camera-filled:before {
        content: "\e658"
    }

    .uniui-chat-filled:before {
        content: "\e659"
    }

    .uniui-camera:before {
        content: "\e65a"
    }

    .uniui-circle:before {
        content: "\e65b"
    }

    .uniui-checkmarkempty:before {
        content: "\e65c"
    }

    .uniui-chat:before {
        content: "\e65d"
    }

    .uniui-circle-filled:before {
        content: "\e65e"
    }

    .uniui-flag:before {
        content: "\e65f"
    }

    .uniui-flag-filled:before {
        content: "\e660"
    }

    .uniui-gear-filled:before {
        content: "\e661"
    }

    .uniui-home:before {
        content: "\e662"
    }

    .uniui-home-filled:before {
        content: "\e663"
    }

    .uniui-gear:before {
        content: "\e664"
    }

    .uniui-smallcircle-filled:before {
        content: "\e665"
    }

    .uniui-map-filled:before {
        content: "\e666"
    }

    .uniui-map:before {
        content: "\e667"
    }

    .uniui-refresh-filled:before {
        content: "\e656"
    }

    .uniui-refresh:before {
        content: "\e657"
    }

    .uniui-cloud-upload:before {
        content: "\e645"
    }

    .uniui-cloud-download-filled:before {
        content: "\e646"
    }

    .uniui-cloud-download:before {
        content: "\e647"
    }

    .uniui-cloud-upload-filled:before {
        content: "\e648"
    }

    .uniui-redo:before {
        content: "\e64a"
    }

    .uniui-images-filled:before {
        content: "\e64b"
    }

    .uniui-undo-filled:before {
        content: "\e64c"
    }

    .uniui-more:before {
        content: "\e64d"
    }

    .uniui-more-filled:before {
        content: "\e64e"
    }

    .uniui-undo:before {
        content: "\e64f"
    }

    .uniui-images:before {
        content: "\e650"
    }

    .uniui-paperclip:before {
        content: "\e652"
    }

    .uniui-settings:before {
        content: "\e653"
    }

    .uniui-search:before {
        content: "\e654"
    }

    .uniui-redo-filled:before {
        content: "\e655"
    }

    .uniui-list:before {
        content: "\e644"
    }

    .uniui-mail-open-filled:before {
        content: "\e63a"
    }

    .uniui-hand-down-filled:before {
        content: "\e63c"
    }

    .uniui-hand-down:before {
        content: "\e63d"
    }

    .uniui-hand-up-filled:before {
        content: "\e63e"
    }

    .uniui-hand-up:before {
        content: "\e63f"
    }

    .uniui-heart-filled:before {
        content: "\e641"
    }

    .uniui-mail-open:before {
        content: "\e643"
    }

    .uniui-heart:before {
        content: "\e639"
    }

    .uniui-loop:before {
        content: "\e633"
    }

    .uniui-pulldown:before {
        content: "\e632"
    }

    .uniui-scan:before {
        content: "\e62a"
    }

    .uniui-bars:before {
        content: "\e627"
    }

    .uniui-cart-filled:before {
        content: "\e629"
    }

    .uniui-checkbox:before {
        content: "\e62b"
    }

    .uniui-checkbox-filled:before {
        content: "\e62c"
    }

    .uniui-shop:before {
        content: "\e62f"
    }

    .uniui-headphones:before {
        content: "\e630"
    }

    .numberStyle {
        flex: 1;
        background-color: #fff;
        height: 32px;
        border-radius: 5px;
        line-height: 32px;
        margin-right: 4px;
    }

    .grid.svelte-1oro30q.svelte-1oro30q {
        display: flex;
        flex-wrap: wrap;
        justify-items: end
    }

    .titles.svelte-1oro30q.svelte-1oro30q {
        display: flex;
        width: 100%
    }

    .titles.svelte-1oro30q>div.svelte-1oro30q {
        line-height: 9vw;
        height: 9vw;
        font-size: 3.6vw;
        background-color: #a5a6a9;
        flex: 1 1 0%;
        overflow: hidden;
        border-right-width: 1px;
        border-style: solid;
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255/var(--tw-border-opacity));
        text-align: center;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .item.svelte-1oro30q.svelte-1oro30q {
        border-color: #ececec;
        cursor: pointer;
        overflow-x: hidden;
        border-width: 1px;
        border-top-width: 0;
        border-left-width: 0;
        border-style: solid;
        text-align: center;
        flex: 1
    }

    .panel.svelte-5yecfq.svelte-5yecfq {
        width: 75vw;
        right: 0;
        overflow: hidden;
        z-index: 40000;
        background-color: #f6f7f8;
        position: fixed;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        transition-property: all;
        transition-duration: .3s;
        transition-timing-function: cubic-bezier(.4, 0, .2, 1)
    }

    .button-grid.svelte-5yecfq.svelte-5yecfq {
        position: relative;
        flex: 1 1 0%;
        overflow: auto
    }

    .menu-item.svelte-5yecfq.svelte-5yecfq {
        padding-bottom: .25rem;
        padding: 3vw
    }

    .menu-item.svelte-5yecfq>h4.svelte-5yecfq {
        font-size: 3.5vw
    }

    .menu-item.svelte-5yecfq svg {
        margin-bottom: .5rem;
        height: 1.75rem;
        width: 1.75rem
    }

    .menu-item.idx0.svelte-5yecfq svg {
        fill: #f39741
    }

    .menu-item.idx1.svelte-5yecfq svg {
        fill: #65c15c
    }

    .menu-item.idx2.svelte-5yecfq svg {
        fill: #b484d8
    }

    .menu-item.idx3.svelte-5yecfq svg {
        fill: #5594e6
    }

    .menu-item.idx4.svelte-5yecfq svg {
        fill: #3bcee9
    }

    .menu-item.idx5.svelte-5yecfq svg {
        fill: #ef6548
    }

    .menu-item.gray.svelte-5yecfq svg {
        fill: #9ca3af
    }

    .menu-item.gray.svelte-5yecfq h4.svelte-5yecfq {
        --tw-text-opacity: 1;
        color: rgb(107 114 128/var(--tw-text-opacity))
    }

    .overlay.svelte-5yecfq.svelte-5yecfq {
        z-index: 39999;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100vw;
        background-color: rgb(0 0 0/var(--tw-bg-opacity));
        --tw-bg-opacity: .3
    }

    .userinfo.svelte-5yecfq.svelte-5yecfq {
        color: #fff;
        font-size: 16px;
        background: linear-gradient(180deg, #39a090, #1f9683);
        display: flex;
        padding-top: 1rem;
        padding-bottom: 1rem
    }

    .userinfo.svelte-5yecfq .avatar.svelte-5yecfq {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }

    .userinfo.svelte-5yecfq .avatar img.svelte-5yecfq {
        width: 5rem;
        border-radius: 9999px
    }

    .userinfo.svelte-5yecfq .info.svelte-5yecfq {
        padding-top: .5rem;
        padding-bottom: .5rem;
        line-height: 2rem
    }

    .userinfo.svelte-5yecfq .info em.svelte-5yecfq {
        font-style: normal
    }

    .logoutbtn.svelte-5yecfq.svelte-5yecfq {
        background-color: #f6f7f8;
        padding: .5rem;
        text-align: center
    }

    .logoutbtn.svelte-5yecfq uni-button.svelte-5yecfq {
        border-radius: .5rem;
        padding-top: .5rem;
        padding-bottom: .5rem;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity));
        font-size: 3.5vw;
        background-image: linear-gradient(180deg, #3bd3ad, #1f9683);
        width: 100%
    }

    .bets-table.svelte-1ryw1kp {
        width: 100%
    }

    .bet-button.svelte-yefhbi.svelte-yefhbi {
        height: 12.5vw;
        align-items: center;
        padding-top: 3px;
        overflow: hidden;
        background-color: #fff
    }

    .value.svelte-yefhbi.svelte-yefhbi {
        position: relative;
        display: flex;
        flex: 1 1 0%;
        justify-content: center;
        overflow: hidden;
        text-align: center
    }

    .value.svelte-yefhbi .circle.svelte-yefhbi,
    .value.svelte-yefhbi .square.svelte-yefhbi {
        width: 6.6vw;
        height: 6.6vw;
        line-height: 6.6vw;
        font-size: 4vw;
        background: #6a68ef;
        display: inline-block;
        border-radius: 9999px;
        text-align: center;
        font-weight: 700;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .value.svelte-yefhbi .color-square.svelte-yefhbi {
        background: unset
    }

    .value.svelte-yefhbi .square.svelte-yefhbi {
        border-radius: 4px
    }

    .value.svelte-yefhbi .text.svelte-yefhbi {
        font-size: 3.5vw;
        line-height: 6vw;
        color: #333;
        display: inline-block;
        font-weight: 700
    }

    .odds.svelte-yefhbi.svelte-yefhbi {
        font-size: 3.2vw;
        line-height: 6vw;
        flex: 1 1 0%;
        align-self: center;
        text-align: center;
        font-weight: 700;
        --tw-text-opacity: 1;
        color: #c55a52
    }

    .sc.svelte-yefhbi.svelte-yefhbi {
        width: 7.2vw;
        height: 7.2vw;
        line-height: 7.2vw;
        font-size: 4vw;
        background: linear-gradient(180deg, #3273f9, #325cb5);
        display: inline-block;
        border-radius: 9999px;
        text-align: center;
        font-weight: 700;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .sc-1.svelte-yefhbi.svelte-yefhbi,
    .sc-2.svelte-yefhbi.svelte-yefhbi,
    .sc-7.svelte-yefhbi.svelte-yefhbi,
    .sc-8.svelte-yefhbi.svelte-yefhbi,
    .sc-12.svelte-yefhbi.svelte-yefhbi,
    .sc-13.svelte-yefhbi.svelte-yefhbi,
    .sc-18.svelte-yefhbi.svelte-yefhbi,
    .sc-19.svelte-yefhbi.svelte-yefhbi,
    .sc-23.svelte-yefhbi.svelte-yefhbi,
    .sc-24.svelte-yefhbi.svelte-yefhbi,
    .sc-29.svelte-yefhbi.svelte-yefhbi,
    .sc-30.svelte-yefhbi.svelte-yefhbi,
    .sc-34.svelte-yefhbi.svelte-yefhbi,
    .sc-35.svelte-yefhbi.svelte-yefhbi,
    .sc-40.svelte-yefhbi.svelte-yefhbi,
    .sc-45.svelte-yefhbi.svelte-yefhbi,
    .sc-46.svelte-yefhbi.svelte-yefhbi {
        background: #d83547
    }

    .sc-3.svelte-yefhbi.svelte-yefhbi,
    .sc-4.svelte-yefhbi.svelte-yefhbi,
    .sc-9.svelte-yefhbi.svelte-yefhbi,
    .sc-10.svelte-yefhbi.svelte-yefhbi,
    .sc-14.svelte-yefhbi.svelte-yefhbi,
    .sc-15.svelte-yefhbi.svelte-yefhbi,
    .sc-20.svelte-yefhbi.svelte-yefhbi,
    .sc-25.svelte-yefhbi.svelte-yefhbi,
    .sc-26.svelte-yefhbi.svelte-yefhbi,
    .sc-31.svelte-yefhbi.svelte-yefhbi,
    .sc-36.svelte-yefhbi.svelte-yefhbi,
    .sc-37.svelte-yefhbi.svelte-yefhbi,
    .sc-41.svelte-yefhbi.svelte-yefhbi,
    .sc-42.svelte-yefhbi.svelte-yefhbi,
    .sc-47.svelte-yefhbi.svelte-yefhbi,
    .sc-48.svelte-yefhbi.svelte-yefhbi {
        background: #2264a4
    }

    .sc-5.svelte-yefhbi.svelte-yefhbi,
    .sc-6.svelte-yefhbi.svelte-yefhbi,
    .sc-11.svelte-yefhbi.svelte-yefhbi,
    .sc-16.svelte-yefhbi.svelte-yefhbi,
    .sc-17.svelte-yefhbi.svelte-yefhbi,
    .sc-21.svelte-yefhbi.svelte-yefhbi,
    .sc-22.svelte-yefhbi.svelte-yefhbi,
    .sc-27.svelte-yefhbi.svelte-yefhbi,
    .sc-28.svelte-yefhbi.svelte-yefhbi,
    .sc-32.svelte-yefhbi.svelte-yefhbi,
    .sc-33.svelte-yefhbi.svelte-yefhbi,
    .sc-38.svelte-yefhbi.svelte-yefhbi,
    .sc-39.svelte-yefhbi.svelte-yefhbi,
    .sc-43.svelte-yefhbi.svelte-yefhbi,
    .sc-44.svelte-yefhbi.svelte-yefhbi,
    .sc-49.svelte-yefhbi.svelte-yefhbi {
        background: #318100
    }

    .bet-panel.svelte-43ckvo.svelte-43ckvo {
        display: flex;
        height: 100%;
        width: 100%
    }

    .nav.svelte-43ckvo.svelte-43ckvo {
        height: 100%;
        overflow-y: auto;
        --tw-bg-opacity: 1;
        background-color: rgb(209 213 219/var(--tw-bg-opacity))
    }

    .nav.svelte-43ckvo>div.svelte-43ckvo {
        width: 20vw;
        height: 10vw;
        line-height: 10vw;
        border-color: #d1d2d6;
        cursor: pointer;
        border-bottom-width: 1px;
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255/var(--tw-border-opacity));
        text-align: center;
        --tw-text-opacity: 1;
        color: rgb(107 114 128/var(--tw-text-opacity))
    }

    .nav.svelte-43ckvo>div.active.svelte-43ckvo {
        background-color: var(--blue);
        color: #fff
    }

    .body.svelte-43ckvo.svelte-43ckvo {
        height: 100%;
        flex: 1 1 0%;
        overflow-y: auto
    }

    .body.svelte-43ckvo .section.svelte-43ckvo {
        display: flex
    }

    .left-button.svelte-43ckvo.svelte-43ckvo {
        height: 12.5vw;
        --tw-text-opacity: 1;
        color: rgb(55 65 81/var(--tw-text-opacity))
    }

    .left-button.svelte-43ckvo i.svelte-43ckvo {
        width: 7.5vw;
        height: 7.5vw;
        line-height: 7.5vw;
        margin-top: .5rem;
        display: inline-block;
        border-radius: .25rem;
        --tw-bg-opacity: 1;
        background-color: rgb(156 163 175/var(--tw-bg-opacity));
        font-weight: 700;
        font-style: normal;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .left-button-1.svelte-43ckvo i.svelte-43ckvo {
        background-color: #ffbe00
    }

    .left-button-2.svelte-43ckvo i.svelte-43ckvo {
        background-color: #0089ff
    }

    .left-button-3.svelte-43ckvo i.svelte-43ckvo {
        background-color: #4d4d4d
    }

    .left-button-4.svelte-43ckvo i.svelte-43ckvo {
        background-color: #ff7300
    }

    .left-button-5.svelte-43ckvo i.svelte-43ckvo {
        background-color: #2bcccc
    }

    .left-button-6.svelte-43ckvo i.svelte-43ckvo {
        background-color: #7f52de
    }

    .left-button-7.svelte-43ckvo i.svelte-43ckvo {
        background-color: #9a9999
    }

    .left-button-8.svelte-43ckvo i.svelte-43ckvo {
        background-color: #ec4949
    }

    .left-button-9.svelte-43ckvo i.svelte-43ckvo {
        background-color: #ad5353
    }

    .left-button-10.svelte-43ckvo i.svelte-43ckvo {
        background-color: #35ad2b
    }

    .game-ssc .left-button.svelte-43ckvo i.svelte-43ckvo {
        text-shadow: 0 1px 0 rgba(0, 0, 0, .53);
        background: linear-gradient(180deg, #3273f9, #325cb5);
        border-radius: 9999px
    }

    .bet-head.svelte-cguzh3.svelte-cguzh3 {
        background-color: var(--primary-color);
        position: relative;
        height: 2.75rem;
        padding-top: .125rem;
        padding-bottom: .125rem;
        line-height: 2.5rem;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .left.svelte-cguzh3.svelte-cguzh3 {
        position: absolute;
        left: 1rem;
        top: 0;
        display: flex;
        cursor: pointer
    }

    .left.svelte-cguzh3 i.svelte-cguzh3 {
        padding-left: .5rem;
        font-size: 1.125rem;
        line-height: 2.5rem
    }

    .right.svelte-cguzh3.svelte-cguzh3 {
        position: absolute;
        right: .5rem;
        top: 0;
        display: flex
    }

    .center.svelte-cguzh3.svelte-cguzh3 {
        text-align: center;
        font-size: 1.125rem;
        font-weight: 700;
        line-height: 2.5rem
    }

    .menus.svelte-cguzh3.svelte-cguzh3 {
        position: absolute;
        top: 2.75rem;
        left: 0;
        width: 100%;
        overflow: auto;
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255/var(--tw-bg-opacity));
        line-height: 1;
        height: 60vh;
        z-index: 20000
    }

    .parent-menu.svelte-cguzh3.svelte-cguzh3 {
        padding: 0 0 0 5%;
        font-size: 22px;
        margin: 24px 0
    }

    .menus.svelte-cguzh3 .title.svelte-cguzh3 {
        margin-bottom: 12px
    }

    .menus.svelte-cguzh3 .menu.svelte-cguzh3 {
        display: inline-block;
        width: 30%;
        border: 1px #eaeaea solid;
        text-align: center;
        color: #777d83;
        border-radius: 4px;
        margin-bottom: 9px;
        margin-right: 3%;
        font-size: 18px;
        height: 48px;
        line-height: 36px;
        padding: 6px 3px;
        box-sizing: border-box;
        overflow: hidden;
        cursor: pointer
    }

    .menus.svelte-cguzh3 .menu.svelte-cguzh3:hover {
        background-color: hsla(0, 0%, 87.1%, .30196078431372547)
    }

    .overlay.svelte-cguzh3.svelte-cguzh3 {
        position: fixed;
        top: 2.75rem;
        left: 0;
        bottom: 0;
        z-index: 30;
        width: 100vw;
        background-color: rgb(0 0 0/var(--tw-bg-opacity));
        --tw-bg-opacity: .3
    }

    .right.svelte-cguzh3 svg {
        fill: currentColor;
        margin-left: .5rem
    }

    .bet-amount.svelte-16uv0rx.svelte-16uv0rx {
        z-index: 300;
        touch-action: manipulation;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%
    }

    .info.svelte-16uv0rx.svelte-16uv0rx {
        width: 280px;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        background-color: #999;
        position: absolute;
        left: 50%;
        z-index: 20;
        height: 2rem;
        border-radius: 1rem;
        text-align: center;
        font-size: .875rem;
        line-height: 2rem;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .info.svelte-16uv0rx em.svelte-16uv0rx {
        font-style: normal
    }

    .quick-amounts.svelte-16uv0rx.svelte-16uv0rx {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: .5rem;
        padding-right: .5rem;
        padding-top: .75rem;
        height: 66px;
        box-shadow: 0 -.26vw .53vw rgba(0, 0, 0, .25098039215686274);
        background-color: #f1f1f1
    }

    .quick-amounts.svelte-16uv0rx>i.svelte-16uv0rx {
        cursor: pointer;
        font-size: 2.25rem;
        line-height: 2.5rem
    }

    .quick-amounts.svelte-16uv0rx span.svelte-16uv0rx {
        font-size: 3.2vw;
        padding: 0 2vw;
        height: 6.5vw;
        width: 6.5vw;
        line-height: 6.5vw
    }

    .bottom.svelte-16uv0rx.svelte-16uv0rx {
        height: 56px;
        background-color: #000;
        padding-left: 1vw;
        padding-right: 1vw;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0;
        padding-bottom: 0;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .bottom.svelte-16uv0rx span.svelte-16uv0rx {
        position: relative;
        display: inline-block;
        cursor: pointer;
        overflow: hidden;
        border-radius: .375rem;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: .25rem;
        padding-right: .25rem;
        text-align: center;
        font-size: 1rem;
        line-height: 1.5rem;
        width: 24vw;
        height: 50px;
        line-height: 50px;
        background-color: #1f9683;
        highlight-color: transparent
    }

    .bottom.svelte-16uv0rx .input.svelte-16uv0rx {
        flex: 1 1 0%;
        overflow: hidden;
        text-align: center
    }

    .bottom.svelte-16uv0rx uni-input.svelte-16uv0rx {
        text-fill-color: currentcolor;
        line-height: 50px;
        height: 50px;
        border: 1px solid #ab3f3e;
        max-width: 48vw;
        font-size: 22px;
        color: #ddd;
        background: transparent;
        width: 100%;
        border-radius: .25rem;
        text-align: center;
        outline: 2px solid transparent;
        outline-offset: 2px
    }

    quick-form.svelte-16uv0rx.svelte-16uv0rx {
        margin-left: 4rem;
        margin-right: 4rem;
        display: block
    }

    qinput.svelte-16uv0rx.svelte-16uv0rx {
        margin-bottom: 1rem;
        display: block
    }

    qinput.svelte-16uv0rx uni-input.svelte-16uv0rx {
        width: 150px;
        border: 1px solid #a9a9a9;
        text-align: center;
        height: 28px;
        color: red;
        outline: none
    }

    quick-form.svelte-16uv0rx uni-button.svelte-16uv0rx {
        width: 60px;
        line-height: 31px;
        border-radius: 3px;
        font-weight: 700;
        margin: 5px;
        text-align: center;
        border: 1px solid #dcdfe6;
        border-color: #999;
        color: #606266;
        font-size: 14px
    }

    quick-form.svelte-16uv0rx uni-button.svelte-16uv0rx:hover {
        color: #1f9683;
        border-color: #1f9683
    }

    quick-form.svelte-16uv0rx uni-button.primary.svelte-16uv0rx {
        color: #fff;
        border-color: #1f9683;
        background-color: #1f9683
    }

    quick-form.svelte-16uv0rx uni-button.primary.svelte-16uv0rx:hover {
        background-color: #1f9683
    }

    .game.svelte-iw28lx.svelte-iw28lx {
        height: 100vh;
        display: flex;
        flex-direction: column
    }

    .hd.svelte-iw28lx.svelte-iw28lx {
        height: 120px
    }

    .bd.svelte-iw28lx.svelte-iw28lx {
        border-top: 1px #ededed solid;
        flex: 1 1 0%;
        overflow-y: auto
    }

    .link-my-bets.svelte-iw28lx.svelte-iw28lx {
        cursor: pointer
    }

    .bet-records.svelte-iw28lx .bd.svelte-iw28lx {
        width: 95%;
        height: 80vh;
        left: 2.5%;
        top: 10vh;
        position: absolute;
        z-index: 40;
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255/var(--tw-bg-opacity))
    }

    .bet-records.svelte-iw28lx .overlay.svelte-iw28lx {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 30;
        width: 100vw;
        background-color: rgb(0 0 0/var(--tw-bg-opacity));
        --tw-bg-opacity: .3
    }

    .bearing-grid.svelte-1b3n0cj.svelte-1b3n0cj {
        background: #dfdfdf;
        width: 100%;
        height: 85vw;
        position: relative;
        display: flex;
        border-top: 1px solid #aaa
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj {
        position: absolute;
        width: 20%;
        height: 17vw;
        border-bottom: 1px solid #aaa;
        border-right: 1px solid #aaa;
        background: #fff;
        text-align: center;
        box-sizing: border-box
    }

    .item-container.checked.svelte-1b3n0cj.svelte-1b3n0cj {
        background: #f9cfcf
    }

    .bet-button.svelte-yefhbi.svelte-yefhbi.checked {
        background-color: #f9cfcf !important
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(2) {
        left: 20%
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(3) {
        left: 40%
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(4) {
        left: 60%
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(5) {
        left: 80%
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(6) {
        left: 80%;
        top: 17vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(7) {
        left: 80%;
        top: 34vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(8) {
        left: 80%;
        top: 51vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(9) {
        left: 80%;
        top: 68vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(10) {
        left: 60%;
        top: 68vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(11) {
        left: 40%;
        top: 68vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(12) {
        left: 20%;
        top: 68vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(13) {
        top: 68vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(14) {
        top: 51vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(15) {
        top: 34vw
    }

    .item-container.svelte-1b3n0cj.svelte-1b3n0cj:nth-child(16) {
        top: 17vw
    }

    .item-container.svelte-1b3n0cj>.item.svelte-1b3n0cj {
        height: 17vw;
        cursor: pointer;
        padding-top: 15px;
        box-sizing: border-box
    }

    .center.svelte-1b3n0cj.svelte-1b3n0cj {
        width: 60%;
        height: 51vw;
        position: absolute;
        left: 20%;
        top: 17vw;
        overflow: hidden;
        box-sizing: border-box;
        border-bottom: 1px solid #aaa;
        border-right: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj {
        position: absolute;
        text-align: center;
        height: 17vw;
        background: #f1f1f1
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(1) {
        width: 50%;
        height: 17vw;
        bottom: 0;
        left: 50%;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        background: #e3e3e3;
        border: none !important
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(1):before {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        top: 0;
        right: -30vw;
        -webkit-transform: rotate(48deg);
        transform: rotate(48deg);
        -webkit-transform-origin: left top;
        transform-origin: left top;
        background: #e3e3e3;
        border-top: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(1):after {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        top: 0;
        left: -30vw;
        -webkit-transform: rotate(-48deg);
        transform: rotate(-48deg);
        -webkit-transform-origin: right top;
        transform-origin: right top;
        background: #e3e3e3;
        border-top: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(2) {
        width: 25%;
        border: none !important;
        height: 17vw;
        top: 17vw;
        left: 75%;
        background: #9cdac4
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(2):before {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        -webkit-transform: rotate(48deg);
        transform: rotate(48deg);
        -webkit-transform-origin: left bottom;
        transform-origin: left bottom;
        background: #9cdac4;
        border-bottom: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(2):after {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        -webkit-transform: rotate(-48deg);
        transform: rotate(-48deg);
        -webkit-transform-origin: left top;
        transform-origin: left top;
        background: #9cdac4
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(3) {
        width: 50%;
        height: 17vw;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        margin: 0;
        background: #ffe693;
        border: none !important;
        z-index: 20
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(3):before {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        bottom: 0;
        right: -30vw;
        -webkit-transform: rotate(-48deg);
        transform: rotate(-48deg);
        -webkit-transform-origin: left bottom;
        transform-origin: left bottom;
        background: #ffe693;
        border-bottom: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(3):after {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        bottom: 0;
        left: -30vw;
        -webkit-transform: rotate(48deg);
        transform: rotate(48deg);
        -webkit-transform-origin: right bottom;
        transform-origin: right bottom;
        background: #ffe693;
        border-bottom: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(4) {
        width: 25%;
        height: 17vw;
        top: 17vw;
        left: 0;
        background: #fbb1a7;
        border: none !important
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(4):before {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        -webkit-transform: rotate(48deg);
        transform: rotate(48deg);
        -webkit-transform-origin: right top;
        transform-origin: right top;
        background: #fbb1a7
    }

    .center.svelte-1b3n0cj .item-container.close:before {
        background: #9f9d9d !important
    }

    .center.svelte-1b3n0cj .item-container.close:after {
        background: #9f9d9d !important
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(4):after {
        display: block;
        width: 30vw;
        height: 17vw;
        content: "";
        position: absolute;
        bottom: 0;
        right: 0;
        -webkit-transform: rotate(-48deg);
        transform: rotate(-48deg);
        -webkit-transform-origin: right bottom;
        transform-origin: right bottom;
        background: #fbb1a7;
        border-bottom: 1px solid #aaa
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(5) {
        display: inline-block;
        width: 25%;
        left: 25%;
        top: 17vw;
        height: 17vw;
        border: 1px solid #aaa;
        border-right: none;
        box-sizing: border-box
    }

    .center.svelte-1b3n0cj .item-container.svelte-1b3n0cj:nth-child(6) {
        display: inline-block;
        width: 25%;
        height: 17vw;
        left: 50%;
        top: 17vw;
        border: 1px solid #aaa;
        box-sizing: border-box
    }

    .center.svelte-1b3n0cj .item-container.checked.svelte-1b3n0cj {
        background: #f9cfcf
    }

    .center.svelte-1b3n0cj .item-container.checked.svelte-1b3n0cj:before {
        background: #f9cfcf
    }

    .center.svelte-1b3n0cj .item-container.checked.svelte-1b3n0cj:after {
        background: #f9cfcf
    }

    .center.svelte-1b3n0cj .item.svelte-1b3n0cj {
        position: relative;
        z-index: 20;
        height: 17vw;
        cursor: pointer;
        box-sizing: border-box;
        padding-top: 2.5vw
    }

    .bet-amount.svelte-m21d8b.svelte-m21d8b {
        z-index: 10;
        touch-action: manipulation;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%
    }

    .info.svelte-m21d8b.svelte-m21d8b {
        width: 280px;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        background-color: #999;
        position: absolute;
        left: 50%;
        z-index: 20;
        height: 32px;
        border-radius: 1rem;
        text-align: center;
        font-size: 14px;
        line-height: 30px;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .info.svelte-m21d8b em.svelte-m21d8b {
        font-style: normal
    }

    .quick-amounts.svelte-m21d8b.svelte-m21d8b {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 10px;
        height: 66px;
        box-shadow: 0 -.26vw .53vw rgba(0, 0, 0, .25098039215686274);
        background-color: #f1f1f1
    }

    .quick-amounts.svelte-m21d8b>i.svelte-m21d8b {
        cursor: pointer;
        font-size: 2.25rem;
        line-height: 2.5rem
    }

    .quick-amounts.svelte-m21d8b span.svelte-m21d8b {
        font-size: 3.2vw;
        padding: 0 2vw;
        height: 6.5vw;
        width: 6.5vw;
        line-height: 6.5vw
    }

    .quick-amounts.svelte-m21d8b span.currp.svelte-m21d8b {
        border-radius: 9999px;
        box-shadow: 0 0 6px 4px #adff2f
    }

    .bottom.svelte-m21d8b.svelte-m21d8b {
        height: 56px;
        background-color: #000;
        padding-left: 1vw;
        padding-right: 1vw;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0;
        padding-bottom: 0;
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }

    .bottom.svelte-m21d8b span.svelte-m21d8b {
        position: relative;
        display: inline-block;
        cursor: pointer;
        overflow: hidden;
        border-radius: .375rem;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: .25rem;
        padding-right: .25rem;
        text-align: center;
        font-size: 14px;
        line-height: 1.5rem;
        width: 24vw;
        height: 50px;
        line-height: 50px;
        background-color: #1f9683;
        highlight-color: transparent
    }

    .bottom.svelte-m21d8b .input.svelte-m21d8b {
        flex: 1 1 0%;
        overflow: hidden;
        text-align: center
    }

    .btnClass[data-v-30d8da26] {
        flex: 1;
        height: 33px;
        line-height: 33px;
        background: #c3c3c3;
        color: #467c4f
    }

    .btnClassActive[data-v-30d8da26] {
        background: #467c4f;
        color: #fff
    }

    .trcss[data-v-30d8da26] {
        border-top: 1px solid #e2e5e8;
        display: flex;
        height: 43px;
        line-height: 43px
    }

    .tdcss[data-v-30d8da26] {
        font-size: 14px;
        color: #37474f;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
    }

    div {
        display: block;
    }
</style>

<style>
    #resultList {
        width: 100%;
        position: fixed;
        top: 4rem;
        z-index: 9;
        background: #f5f7fa;
        border-top: 1px solid #e1e6eb;
        border-bottom: 1px solid #e1e6eb;
        line-height: 2rem;
        overflow: hidden
    }

    #resultList .result {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e1e6eb
    }

    #headerData {
        width: 100%;
        position: fixed;
        top: 2rem;
        z-index: 9;
        display: flex;
        justify-content: space-between;
        background: #f5f7fa;
        border-top: 1px solid #e1e6eb;
        border-bottom: 1px solid #e1e6eb;
        height: 2rem;
        line-height: 2rem;
        overflow: hidden
    }

    .issue {
        /* width: 20%; */
        padding-left: 10px
    }

    .sscnum {
        padding-top: 6px;
        /* padding-right: 5px; */
        text-align: center
    }

    .time {
        width: 14%;
        color: red;
        padding-right: 10px;
        text-align: right
    }

    .flex {
        display: flex
    }

    #pk10num li {
        font-size: 14px;
        width: 21px;
        height: 21px;
        line-height: 21px
    }

    .sscli li {
        text-align: center;
        color: #fff;
        background: #0092dd;
        box-sizing: border-box;
        border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        margin-right: 3px
    }

    .userinfo {
        text-align: center;
        width: 100%;
        position: fixed;
        z-index: 10;
        background: #f5f7fa;
        border-top: 1px solid #e1e6eb;
        border-bottom: 1px solid #e1e6eb;
        height: 2rem;
        line-height: 2rem;
        overflow: hidden
    }

    .c,
    .start span {
        display: inline-block;
        width: 4%;
        text-align: center
    }

    .c,
    .start p {
        display: inline-block;
        padding: 0;
        margin: 0;
        width: 4%;
        text-align: center
    }

    .jfzb span {
        display: inline-block;
        width: 42px
    }

    .jfzb p {
        display: inline-block;
        padding: 0;
        margin: 0;
        width: 42px
    }

    .van-field__body input {
        background-color: #f4f4f5;
        text-indent: 0.5em;
    }

    .dates span,
    .types span {
        margin-left: 10px;
        cursor: pointer;
        position: relative;
    }

    .dates span.sele,
    .types span.sele {
        font-weight: 500;
    }

    .dates span.sele:after,
    .types span.sele:after {
        border-bottom: 3px solid #ee0a24;
        position: absolute;
        content: '';
        width: 40px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
    }

    .types span.sele:after {
        border-bottom: 3px solid #0af;
    }

    .infoitem {
        border-radius: 4px;
        border: 1px solid #000;
        background: #dff4ff;
        margin: 2px;
        padding: 5px;
    }

    .infoitem.chi {
        background: #b2b2de;
    }

    .infoitem.sele {
        border: 2px solid orange;
    }

    .liu {
        border: 2px solid orange;
    }

    .infoitem.is_excep {
        background: red;
        color: #fff;
    }

    .infoitem.is_excep .infoitem_row {
        background: #fcc9c9 !important;
        color: #000000 !important;
    }

    .infoitem.is_excep .all_fanshui {
        color: #ffffff !important;
    }

    .infoitem.is_tuo {
        background: #b2b2de;
    }

    .infolist .item_top span {
        font-weight: bold;
        margin: 2px;
    }

    .infolist .infoitem_row {
        position: relative;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #000;
    }

    .infoitem_row.type1 {
        background: #efefef;
    }

    .infolist .infoitem_row span {
        margin-right: 0px;
    }

    .infolist .infoitem_row .rowqi {
        display: inline-block;
    }

    .infolist .infoitem_row span.tuo {
        position: absolute;
        top: -10px;
        left: 67px;
        background: darkblue;
        display: block;
        width: 20px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent {
        padding: 2px;
        background: #808080;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.sf {
        background: red;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.xf {
        background: green;
        color: #fff;
    }

    .infolist .infoitem_row .fanshui {
        color: red;
        font-size: 14px;
    }

    .infolist .infoitem_row .rowchange.win {
        color: red;
    }

    .infolist .infoitem_row .rowchange.lose {
        color: green;
    }

    .infolist .infoitem_row .rowscore {
        font-weight: bold;
    }

    .infolist .profit_loss.changescore:before {
        content: '改分';
        color: #ffffff;
        background: red;
        font-weight: bold;
    }

    .infolist .all_fanshui {
        color: red;
        display: none;
        font-weight: bold;
    }

    .item_detail {}

    .tt1 {
        margin-top: 5px;
        font-size: 16px;
    }

    .custom-block.tip {
        padding: 8px 16px;
        background-color: #409eff1a;
        border-radius: 4px;
        border-left: 5px solid #409eff;
        margin: 20px 0;
    }

    .custom-block .custom-block-title {
        font-weight: 700;
        margin-bottom: 8px;
        font-size: 16px;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
        font-size: 16px;
    }

    .

    /* el-tabs__nav-wrap::after {
        height: 0px !important;
    }

    .el-tabs__header {
        margin: 0 !important;
    } */
    .el-collapse {
        border: none !important;
    }

    .el-collapse-item__header {
        display: block !important;
        height: auto !important;
        line-height: inherit !important;
        background: none !important;
        border-bottom: none !important;
        font-size: inherit !important;
        font-weight: inherit !important;
    }

    .el-collapse-item__arrow {
        display: none !important;
    }

    .el-collapse-item__wrap {
        background: none !important;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
        font-size: inherit !important;
        line-height: inherit !important;
    }
</style>
